// Generated by Avo VERSION 172.19.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Staging = "staging",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "08x2H3eWZd8gAG8XGLnE";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "7GlN1ELvRcA8O2nD0Zm3",
          "br": "2LaGwaVhj",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "YVbONYzfD",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "7GlN1ELvRcA8O2nD0Zm3",
          "br": "2LaGwaVhj",
          "en": env,
          "ty": type,
          "sc": "JmwsgKTQe50MTmUE9FVs",
          "se": (new Date()).toISOString(),
          "so": "YVbONYzfD",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "JmwsgKTQe50MTmUE9FVs",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface ProductsCart {
  amount: number
  identifier: string
  variation: string
  currency: CurrencyValueType
  quantity: number
  marketingcloudpid: string
  variantId: string
}

export interface Products {
  productId: string
  category: string
  itemCategory2: string | null | undefined
  itemCategory3: string | null | undefined
  itemCategory4: string | null | undefined
  itemCategory5: string | null | undefined
  affiliation: AffiliationValueType
  itemListName: string
  variant: string | null | undefined
  price: number
  quantity: number
  currency: CurrencyValueType
  position: number
  imageUrl: string
  onlineMaterial: string
  fitId: string | null | undefined
  plpGridImages: string
  shopTheLookId: string | null | undefined
  mixAndMatch: MixAndMatchValueType
  productSetId: string | null | undefined
  name: string
  listId: string
  sku: string
  fullLook: string | null | undefined
  value: number
  locationId: string
  url: string
  customSize: boolean | null | undefined
  includedAlterations: boolean | null | undefined
  hasSizepassport: boolean | null | undefined
  outOfStock: boolean | null | undefined
  sliderImageNumber: number | null | undefined
  hasImageSliderInteraction: boolean | null | undefined
}

export const MixAndMatch = {
  'TRUE': 'true',
  'FALSE': 'false',
} as const;
export type MixAndMatchType = typeof MixAndMatch;
export type MixAndMatchValueType = MixAndMatchType[keyof MixAndMatchType];

export const Language = {
  'EN': 'en',
  'ES': 'es',
  'FR': 'fr',
  'DE': 'de',
  'IT': 'it',
  'SV': 'sv',
  'PL': 'pl',
  'ZH': 'zh',
  'KO': 'ko',
} as const;
export type LanguageType = typeof Language;
export type LanguageValueType = LanguageType[keyof LanguageType];

export const NewCountry = {
  'AE': 'ae',
  'AT': 'at',
  'AU': 'au',
  'BE': 'be',
  'BG': 'bg',
  'BN': 'bn',
  'CA': 'ca',
  'CH': 'ch',
  'CN': 'cn',
  'CY': 'cy',
  'CZ': 'cz',
  'DE': 'de',
  'DK': 'dk',
  'DO': 'do',
  'EE': 'ee',
  'ES': 'es',
  'FI': 'fi',
  'FR': 'fr',
  'GB': 'gb',
  'GH': 'gh',
  'GI': 'gi',
  'GP': 'gp',
  'GR': 'gr',
  'GW': 'gw',
  'HK': 'hk',
  'HR': 'hr',
  'HU': 'hu',
  'IE': 'ie',
  'IN': 'in',
  'IR': 'ir',
  'IS': 'is',
  'IT': 'it',
  'JE': 'je',
  'JP': 'jp',
  'KR': 'kr',
  'LI': 'li',
  'LT': 'lt',
  'LU': 'lu',
  'LV': 'lv',
  'LY': 'ly',
  'MC': 'mc',
  'MO': 'mo',
  'MQ': 'mq',
  'MT': 'mt',
  'MV': 'mv',
  'MY': 'my',
  'NL': 'nl',
  'NO': 'no',
  'PL': 'pl',
  'PR': 'pr',
  'PT': 'pt',
  'QA': 'qa',
  'RO': 'ro',
  'SE': 'se',
  'SG': 'sg',
  'SI': 'si',
  'SK': 'sk',
  'TT': 'tt',
  'US': 'us',
} as const;
export type NewCountryType = typeof NewCountry;
export type NewCountryValueType = NewCountryType[keyof NewCountryType];

export const LoggedIn = {
  'TRUE': 'true',
  'FALSE': 'false',
} as const;
export type LoggedInType = typeof LoggedIn;
export type LoggedInValueType = LoggedInType[keyof LoggedInType];

export const EventCategory = {
  'CHECKOUT_INTERACTIONS': 'checkout_interactions',
  'PLP_INTERACTIONS': 'plp_interactions',
  'PDP_INTERACTIONS': 'pdp_interactions',
  'GLOBAL_INTERACTIONS': 'global_interactions',
  'FOOTER_INTERACTIONS': 'footer_interactions',
  'JOURNAL_INTERACTIONS': 'journal_interactions',
  'CM_INTERACTIONS': 'cm_interactions',
  'LOOKBUILDER_INTERACTIONS': 'lookbuilder_interactions',
  'INSTORE_INTERACTIONS': 'instore_interactions',
  'ECOMMERCE_INTERACTIONS': 'ecommerce_interactions',
  'BTC_INTERACTIONS': 'btc_interactions',
  'BOOKING_INTERACTIONS': 'booking_interactions',
  'LOGIN_INTERACTIONS': 'login_interactions',
  'SP_INTERACTIONS': 'sp_interactions',
  'CONFIGURATOR_INTERACTIONS': 'configurator_interactions',
} as const;
export type EventCategoryType = typeof EventCategory;
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType];

export const Country = {
  'US': 'us',
  'CA': 'ca',
  'NL': 'nl',
  'GB': 'gb',
  'DE': 'de',
  'FR': 'fr',
  'BE': 'be',
  'IT': 'it',
  'SE': 'se',
  'CH': 'ch',
  'PL': 'pl',
  'ES': 'es',
  'FI': 'fi',
  'DK': 'dk',
  'AT': 'at',
  'NO': 'no',
  'CZ': 'cz',
  'HR': 'hr',
  'HU': 'hu',
  'EE': 'ee',
  'LV': 'lv',
  'LT': 'lt',
  'GR': 'gr',
  'IE': 'ie',
  'SG': 'sg',
  'IN': 'in',
  'AU': 'au',
  'CN': 'cn',
  'BN': 'bn',
  'JP': 'jp',
  'HK': 'hk',
  'MO': 'mo',
  'MV': 'mv',
  'MY': 'my',
  'IR': 'ir',
  'LY': 'ly',
  'PT': 'pt',
  'RO': 'ro',
  'CY': 'cy',
  'SK': 'sk',
  'BG': 'bg',
  'SI': 'si',
  'AE': 'ae',
  'GH': 'gh',
  'GI': 'gi',
  'GW': 'gw',
  'IS': 'is',
  'JE': 'je',
  'LI': 'li',
  'MC': 'mc',
  'MT': 'mt',
  'QA': 'qa',
  'DO': 'do',
  'GP': 'gp',
  'MQ': 'mq',
  'PR': 'pr',
  'TT': 'tt',
  'KR': 'kr',
  'LU': 'lu',
} as const;
export type CountryType = typeof Country;
export type CountryValueType = CountryType[keyof CountryType];

export const Affiliation = {
  'WEBSTORE_EUR': 'webstore-eur',
  'WEBSTORE_USD': 'webstore-usd',
  'WEBSTORE_CAD': 'webstore-cad',
  'WEBSTORE_PLN': 'webstore-pln',
  'WEBSTORE_AUD': 'webstore-aud',
  'WEBSTORE_SEK': 'webstore-sek',
  'WEBSTORE_CHF': 'webstore-chf',
  'WEBSTORE_DKK': 'webstore-dkk',
  'WEBSTORE_AED': 'webstore-aed',
  'WEBSTORE_NOK': 'webstore-nok',
  'WEBSTORE_CNY': 'webstore-cny',
  'WEBSTORE_SGD': 'webstore-sgd',
  'WEBSTORE_HKD': 'webstore-hkd',
  'WEBSTORE_GBP': 'webstore-gbp',
  'WEBSTORE_KRW': 'webstore-krw',
} as const;
export type AffiliationType = typeof Affiliation;
export type AffiliationValueType = AffiliationType[keyof AffiliationType];

export const Brand = {
  'SUITSUPPLY': 'suitsupply',
} as const;
export type BrandType = typeof Brand;
export type BrandValueType = BrandType[keyof BrandType];

export const PageType = {
  'HOME': 'home',
  'PRODUCT': 'product',
  'CATEGORY': 'category',
  'JOURNAL': 'journal',
  'STORE': 'store',
  'LOOKBUILDER': 'lookbuilder',
  'LOGIN': 'login',
  'WISHLIST': 'wishlist',
  'ACCOUNT': 'account',
  'CHECKOUT': 'checkout',
  'CART': 'cart',
  'SUPPORT': 'support',
  'CUSTOMMADE': 'custommade',
  'GIFTCARD': 'giftcard',
  'ERROR': 'error',
  'INSTORE': 'instore',
  'CATEGORY_LANDING': 'category_landing',
  'BLACK_TIE_CONFIGURATOR': 'black-tie-configurator',
  'MINI_CART': 'mini-cart',
  'BLACK_TIE_CONFIGURATOR': 'black_tie_configurator',
  'PRODUCT_DETAIL_PAGE': 'product_detail_page',
  'PRODUCT_LIST_PAGE': 'product_list_page',
  'ORDER_CONFIRMATION': 'order_confirmation',
  'BOOKING_TOOL': 'booking_tool',
} as const;
export type PageTypeType = typeof PageType;
export type PageTypeValueType = PageTypeType[keyof PageTypeType];

export const Currency = {
  'EUR': 'eur',
  'USD': 'usd',
  'CNY': 'cny',
  'AUD': 'aud',
  'BGN': 'bgn',
  'CAD': 'cad',
  'CZK': 'czk',
  'DKK': 'dkk',
  'HKD': 'hkd',
  'HUF': 'huf',
  'ISK': 'isk',
  'INR': 'inr',
  'JPY': 'jpy',
  'CHF': 'chf',
  'MOP': 'mop',
  'MYR': 'myr',
  'NOK': 'nok',
  'QAR': 'qar',
  'RON': 'ron',
  'SGD': 'sgd',
  'SEK': 'sek',
  'AED': 'aed',
  'GBP': 'gbp',
  'PLN': 'pln',
  'KRW': 'krw',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const Creative = {
  'HOMEPAGE_ADBLOCK': 'homepage_adblock',
  'HOMEPAGE_RELATED_ARTICLE': 'homepage_related-article',
  'HOMEPAGE_USP': 'homepage_usp',
  'HOMEPAGE_TEXTLINK': 'homepage_textlink',
  'HOMEPAGE_SEOBLOCK': 'homepage_seoblock',
  'FOOTER_LINK': 'footer_link',
  'FOOTER_USP': 'footer_usp',
  'PLP_HEADER': 'plp_header',
  'PLP_ADBLOCK': 'plp_adblock',
  'PLP_WIDGET': 'plp_widget',
  'JOURNAL_HUB_RELATED_ARTICLES': 'journal-hub_related-articles',
  'JOURNAL_HUB_ADBLOCK': 'journal-hub_adblock',
  'JOURNAL_HUB_HEADER': 'journal-hub_header',
  'JOURNAL_BUTTONLINK': 'journal_buttonlink',
  'JOURNAL_ADBLOCK': 'journal_adblock',
  'JOURNAL_TEXTLINK': 'journal_textlink',
  'PDP_ACCORDION': 'pdp_accordion',
  'PDP_EMBEDDED_ARTICLE': 'pdp_embedded-article',
  'PDP_USP': 'pdp_usp',
  'PDP_RELATED_ARTICLES': 'pdp_related-articles',
  'PDP_BUTTONLINK': 'pdp_buttonlink',
  'PDP_PANEL': 'pdp_panel',
  'STORE_TEXTLINK': 'store_textlink',
  'STORE_ADBLOCK': 'store_adblock',
  'STORE_FAQLINK': 'store_faqlink',
  'STORE_OVERVIEW_TEXTLINK': 'store-overview_textlink',
  'STORE_SEARCH_TEXTLINK': 'store-search_textlink',
  'STORE_SEARCH_SLIDER_TEXTLINK': 'store-search_slider-textlink',
  'STORE_SEARCH_ADBLOCK': 'store-search_adblock',
  'PDP_PANEL_WISHLIST': 'pdp_panel_wishlist',
  'PLP_PANEL_WISHLIST': 'plp_panel_wishlist',
  'PDP_BUTTONLINK_MWTW': 'pdp_buttonlink_mwtw',
  'PDP_PANEL_MWTW': 'pdp_panel_mwtw',
  'PDP_USP_MWTW': 'pdp_usp_mwtw',
  'PDP_PANEL_SA': 'pdp_panel_sa',
  'FOOTER_PANEL_SA': 'footer_panel_sa',
  'PANEL_MINICART': 'panel_minicart',
  'LOOKBUILDER_SUMMARY_ADBLOCK': 'lookbuilder-summary_adblock',
  'SHOP_THE_LOOK_USP': 'shop-the-look_usp',
  'SHOP_THE_LOOK_PANEL': 'shop-the-look_panel',
  'PDP_ICONLINK_MWTW': 'pdp_iconlink_mwtw',
  'CLP_ADBLOCK': 'clp_adblock',
  'CLP_BUTTONLINK': 'clp_buttonlink',
  'PDP_SHOP_THE_LOOK_SLIDER': 'pdp_shop_the_look_slider',
  'PDP_SLIDER_SHOP_THE_LOOK': 'pdp_slider_shop_the_look',
} as const;
export type CreativeType = typeof Creative;
export type CreativeValueType = CreativeType[keyof CreativeType];

export const ApplicationId = {
  'CUSTOM_MADE': 'custom_made',
  'HEADLESS': 'headless',
  'LOOKBUILDER': 'lookbuilder',
  'ONLINE_STORE': 'online_store',
  'SIZE_PASSPORT': 'size_passport',
  'BOOKING_TOOL': 'booking_tool',
} as const;
export type ApplicationIdType = typeof ApplicationId;
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType];

let sysApplicationId: any;
let sysVersion: any;
let sysClientId: any;
let sysSessionId: any;

export function setSystemProperties(properties: {applicationId: ApplicationIdValueType;
    version: string;
    clientId: string;
    sessionId: string}) {
if (properties.applicationId !== null && properties.applicationId !== undefined) {
  sysApplicationId = properties.applicationId;
}
if (properties.version !== null && properties.version !== undefined) {
  sysVersion = properties.version;
}
if (properties.clientId !== null && properties.clientId !== undefined) {
  sysClientId = properties.clientId;
}
if (properties.sessionId !== null && properties.sessionId !== undefined) {
  sysSessionId = properties.sessionId;
}
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {applicationId: ApplicationIdValueType;
    version: string;
    clientId: string;
    sessionId: string},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

setSystemProperties(systemProperties);

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}
if (__AVO_ENV__ === AvoEnv.Staging) {
}

Segment = SegmentDestination;
if (__AVO_ENV__ === 'prod') {
  Segment && Segment.make && Segment.make(__AVO_ENV__, "4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG");
} else if (__AVO_ENV__ === 'dev') {
  Segment && Segment.make && Segment.make(__AVO_ENV__, null);
} else {
  Segment && Segment.make && Segment.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

function assertPrice(price: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertFloat("5RMsvPEmT", _label ? "price" + ': ' + _label : "price", price));
messages = messages.concat(AvoAssert.assertMin("5RMsvPEmT", _label ? "price" + ": " + _label : "price", 0.000000, price));
return messages;
}

function assertValue(value: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertFloat("Kddfsr3Xx", _label ? "value" + ': ' + _label : "value", value));
messages = messages.concat(AvoAssert.assertMin("Kddfsr3Xx", _label ? "value" + ": " + _label : "value", 0.000000, value));
return messages;
}

function assertProductsCart(productsCart: ProductsCart[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("NbRKFviNt", "products_cart", productsCart));
if (productsCart !== null && productsCart !== undefined && productsCart.forEach) {
  productsCart.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("NbRKFviNt", "item at index " + index + " in products_cart", value));
    messages = messages.concat(assertAmount(value.amount, "item at index " + index + " in products_cart"));
    messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in products_cart"));
});
}
return messages;
}

function assertProductsCartOptional(productsCart: ProductsCart[] | null | undefined,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
if (productsCart !== undefined && productsCart !== null) {
  messages = messages.concat(AvoAssert.assertList("NbRKFviNt", "products_cart", productsCart));
  productsCart.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("NbRKFviNt", "item at index " + index + " in products_cart", value));
    messages = messages.concat(assertAmount(value.amount, "item at index " + index + " in products_cart"));
    messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in products_cart"));
});
}
return messages;
}

function assertAmount(amount: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertFloat("Vk6lWRKl5", _label ? "amount" + ': ' + _label : "amount", amount));
messages = messages.concat(AvoAssert.assertMin("Vk6lWRKl5", _label ? "amount" + ": " + _label : "amount", 0.000000, amount));
return messages;
}

function assertQuantity(quantity: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("fg1kaNXr_", _label ? "quantity" + ': ' + _label : "quantity", quantity));
messages = messages.concat(AvoAssert.assertMin("fg1kaNXr_", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
return messages;
}

function assertPosition(position: number,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertInt("pBPbnpdFj", _label ? "position" + ': ' + _label : "position", position));
messages = messages.concat(AvoAssert.assertMin("pBPbnpdFj", _label ? "position" + ": " + _label : "position", 1, position));
return messages;
}

function assertProducts(products: Products[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("rg6ssTw5D", "products", products));
if (products !== null && products !== undefined && products.forEach) {
  products.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("rg6ssTw5D", "item at index " + index + " in products", value));
    messages = messages.concat(assertPrice(value.price, "item at index " + index + " in products"));
    messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in products"));
    messages = messages.concat(assertPosition(value.position, "item at index " + index + " in products"));
    messages = messages.concat(assertValue(value.value, "item at index " + index + " in products"));
});
}
return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface ProductListViewedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string;
  itemListName: string;
  products: Products[];
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user.
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.products: An array of products needed for the specific event
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/syjGhZU5cD}
 */
export function productListViewed(properties: ProductListViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "syjGhZU5cD", "8722925ec94fb615638da1d86c92da1e4511b3a8ce08cd7290371d1973bc5f1f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("syjGhZU5cD", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD", "8722925ec94fb615638da1d86c92da1e4511b3a8ce08cd7290371d1973bc5f1f");
}
// destination Segment
Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductListViewedSimilarProductsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  products: Products[];
  eventLocation: string;
}
/**
 * Product List Viewed: This event represents a list of items presented to the user. It includes the list_id, which identifies the item list, as well as the list name. Additionally, it contains an object that encompasses all products displayed to the user., event variant
 * 
 * When to trigger this event:
 * 1. When the "Similar products" list is shown
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/syjGhZU5cD.wSIdD0UWx/trigger/uCUQTq1a0b4
 * 2. When the "Similar products" list is shown
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/syjGhZU5cD.wSIdD0UWx/trigger/6WiyLpXsBF7
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.products: An array of products needed for the specific event
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/syjGhZU5cD.wSIdD0UWx}
 */
export function productListViewedSimilarProducts(properties: ProductListViewedSimilarProductsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: "similar_products"});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: "similar products"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "syjGhZU5cD.wSIdD0UWx", "469aa30d9c6cdb3a007a1d3daa38d97ff066c8a168ed0b0951cc8d89099b4ef6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("syjGhZU5cD.wSIdD0UWx", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "syjGhZU5cD.wSIdD0UWx", "469aa30d9c6cdb3a007a1d3daa38d97ff066c8a168ed0b0951cc8d89099b4ef6");
}
// destination Segment
Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string | null | undefined;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
}
/**
 * Product Clicked: When clicking on a product to go to PLP, or in a panel when clicking on 'select size' When a product is shown in the viewport

 * 
 * When to trigger this event:
 * 1. When clicking on a product on a PLP
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/hFTLKlhB8
 * 2. When clicking on a product on a PDP in the 'You Might Also Like' carousel. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/uc6_I1PJe
 * 3. When clicking on 'Select Size' in the 'Shop the Look' panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/2eMjubKrf
 * 4. When clicking on a product on a Journal
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/cWUk2zzqA
 * 5. When clicking on a product on the store locator page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/Bpf-If4w-
 * 6. When clicking on a product on a store detail page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/D-ioHoDIM
 * 7. When clicking on 'shop giftcard' button, on the Giftcard landing page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3/trigger/ecFszVd66
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3}
 */
export function productClicked(properties: ProductClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
properties.shopTheLookId !== undefined && properties.shopTheLookId !== null ?
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId}) :
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: null});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "kHvR74th3", "f3b498dc615694fb6841c7ea7fd147d0211e1c4bdae4aeb68f8fbaae57b252de", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("kHvR74th3", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "kHvR74th3", "f3b498dc615694fb6841c7ea7fd147d0211e1c4bdae4aeb68f8fbaae57b252de");
}
// destination Segment
Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductClickedSimilarProductsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string | null | undefined;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * Product Clicked: When clicking on a product to go to PLP, or in a panel when clicking on 'select size' When a product is shown in the viewport, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks on a product in the "Similar Products" list
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3.ifkXa9S8M/trigger/RrxM61iG8tm
 * 2. When the user clicks on a product in the "Similar Products" list
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3.ifkXa9S8M/trigger/eCmOMXGWZye
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kHvR74th3.ifkXa9S8M}
 */
export function productClickedSimilarProducts(properties: ProductClickedSimilarProductsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
properties.shopTheLookId !== undefined && properties.shopTheLookId !== null ?
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId}) :
  eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: null});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: "similar_products"});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: "similar products"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "kHvR74th3.ifkXa9S8M", "f5eb60743f483586f5119c54cfaf83f4439c6ad254867d6b88e0f62bcb725ae9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("kHvR74th3.ifkXa9S8M", "Product Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Clicked", eventProperties, "kHvR74th3.ifkXa9S8M", "f5eb60743f483586f5119c54cfaf83f4439c6ad254867d6b88e0f62bcb725ae9");
}
// destination Segment
Segment.logEvent("Product Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductViewedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string | null | undefined;
  itemListName: string | null | undefined;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string | null | undefined;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
}
/**
 * Product Viewed: When landing an a PDP, or clicking on 'select size' in panel

 * 
 * When to trigger this event:
 * 1. When clicking on 'Select Size' in the 'Shop the Look' panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4a040kO3L/trigger/biZR2zvCbF
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4a040kO3L}
 */
export function productViewed(properties: ProductViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.listId !== undefined && properties.listId !== null ?
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId}) :
  eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: null});
properties.itemListName !== undefined && properties.itemListName !== null ?
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName}) :
  eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: null});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
properties.variant !== undefined && properties.variant !== null ?
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant}) :
  eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: null});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "4a040kO3L", "940f88f9c3da6e5eeb446a612ad78fff83c3809d6c25acc0af9c0fb22712fba4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("4a040kO3L", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "4a040kO3L", "940f88f9c3da6e5eeb446a612ad78fff83c3809d6c25acc0af9c0fb22712fba4");
}
// destination Segment
Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductAddedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  value: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  productsCart: ProductsCart[];
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  hasUsedSizepassport: boolean;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
for Custommade: when clicking on 'add to bag' on the summary screen.
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.value: Price * Quantity
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event. 
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/0mNPEK9jV}
 */
export function productAdded(properties: ProductAddedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: properties.productsCart.map(function(value) { return {
    "amount": value.amount,
    "identifier": value.identifier,
    "variation": value.variation,
    "currency": value.currency,
    "quantity": value.quantity,
    "marketingcloudpid": value.marketingcloudpid,
    "variant_id": value.variantId,
}
})});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  messages = messages.concat(assertProductsCart(properties.productsCart));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0mNPEK9jV", "6736d3cd7f124eb99af3dd3c75208997f66c165202159540974328db84ccf9df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0mNPEK9jV", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV", "6736d3cd7f124eb99af3dd3c75208997f66c165202159540974328db84ccf9df");
}
// destination Segment
Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductAddedCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  price: number;
  quantity: number;
  position: number;
  value: number;
  imageUrl: string;
  plpGridImages: string;
  shopTheLookId: string;
  productsCart: ProductsCart[];
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  hasUsedSizepassport: boolean;
}
/**
 * Product Added: When clicking on 'add to bag' on a PDP, panel or increasing value on the cart page. 
for Custommade: when clicking on 'add to bag' on the summary screen., event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.value: Price * Quantity
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event. 
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.hasUsedSizepassport: This property specifies whether the user has used their size passport for the product. It should return true or false.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/0mNPEK9jV.a9tlg0c-F}
 */
export function productAddedCm(properties: ProductAddedCmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: properties.productsCart.map(function(value) { return {
    "amount": value.amount,
    "identifier": value.identifier,
    "variation": value.variation,
    "currency": value.currency,
    "quantity": value.quantity,
    "marketingcloudpid": value.marketingcloudpid,
    "variant_id": value.variantId,
}
})});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "ZzQnqmPf5AKizBPYD2cW3", name: "has_used_sizepassport", value: properties.hasUsedSizepassport});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  messages = messages.concat(assertProductsCart(properties.productsCart));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0mNPEK9jV.a9tlg0c-F", "4c3c3bdb553385fb12a6bc82715cab266d5ace624710434f61ac690efca4e4c1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0mNPEK9jV.a9tlg0c-F", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "0mNPEK9jV.a9tlg0c-F", "4c3c3bdb553385fb12a6bc82715cab266d5ace624710434f61ac690efca4e4c1");
}
// destination Segment
Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PageLoadedProperties {
  customDestinationPageName_: string;
  localeVisited: string;
  productsCart: ProductsCart[] | null | undefined;
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaAwClid: string | null | undefined;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
for custommade: products_cart and referrer not needed
 * 
 * When to trigger this event:
 * 1. Title: instore - checkin - login
url: https://suitsupply.com/en-nl//instore/checkin-login/
location_id: https://suitsupply.com/en-nl//instore/checkin-login/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/GzKmdfzMs
 * 2. title: instore - checkin - register
location_id: https://suitsupply.com/en-nl/instore/checkin-register/
url: https://suitsupply.com/instore/checkin-register/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/h5T0sz4zf
 * 3. title: instore - checkin - long succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-long/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-long/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/WL4lVMb0g
 * 4. title: instore - checkin - short succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-short/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-short/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/Djt5Cknvx
 * 5. 1. black-tie-configurator page 1 (jacket):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/jacket


location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/jacket
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/bjjJ9GC32
 * 6. 3.black-tie-configurator page 3 (trousers):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/trousers

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/trousers
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/9N-3rJX7w
 * 7. 4.black-tie-configurator page 4 (shirt):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/shirt

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/shirt
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/hRyZsTCWg
 * 8. 5.black-tie-configurator page 5 (shoes):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/shoes

location_id:

Two piece::
https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/shoes
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/SgNDh79wH
 * 9. 6.black-tie-configurator page 6 (bow-tie):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/bowtie

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/bowtie
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/fqSg1J0Lw
 * 10. 7.black-tie-configurator page 7 (cufflinks):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/cufflinks


location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/cufflinks
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/bObRbcuk9
 * 11. 8.black-tie-configurator page 8 (suspenders):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/suspenders

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/suspenders
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/sW1aJ_pG0
 * 12. 9.black-tie-configurator page 9 (summary):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/summary

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/summary
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/dmE9uQLdg
 * 13. 1b.black-tie-configurator page 1b (jacket lapel):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/jacket/lapel


location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/jacket/lapel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/tfcaQfTbT
 * 14. 2.black-tie-configurator page 1 (waistcoat):

url: 

https://suitsupply.com/men/black-tie-package/mix-match-tuxedo/waistcoat

location_id:

https://suitsupply.com/en-nl/men/black-tie-package/mix-match-tuxedo/waistcoat
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/JtGp7KJRc
 * 15. page_type: category_landing
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226/trigger/A-zNqBmM1
 * 
 * @param properties the properties associatied with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event. 
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226}
 */
export function pageLoaded(properties: PageLoadedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
properties.productsCart !== undefined && properties.productsCart !== null ?
  eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: properties.productsCart.map(function(value) { return {
      "amount": value.amount,
      "identifier": value.identifier,
      "variation": value.variation,
      "currency": value.currency,
      "quantity": value.quantity,
      "marketingcloudpid": value.marketingcloudpid,
      "variant_id": value.variantId,
  }
})}) :
eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: null});
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProductsCartOptional(properties.productsCart));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "4l0ZskS226", "7897b87755c2d6b48bbac666638c2c0e8e3064dda19fa3221450cf0509cd087c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("4l0ZskS226", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Page Loaded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  // destination Segment
  if (Segment.logPage) {
    Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface PageLoadedVirtualPageViewProperties {
  customDestinationPageName_: string;
  localeVisited: string;
  productsCart: ProductsCart[] | null | undefined;
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaAwClid: string | null | undefined;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
}
/**
 * Page Loaded: When a page or a virtual page is loaded
for custommade: products_cart and referrer not needed, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event. 
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4l0ZskS226.zXISHUvOO}
 */
export function pageLoadedVirtualPageView(properties: PageLoadedVirtualPageViewProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "QSRXqGwpG", name: "locale_visited", value: properties.localeVisited});
properties.productsCart !== undefined && properties.productsCart !== null ?
  eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: properties.productsCart.map(function(value) { return {
      "amount": value.amount,
      "identifier": value.identifier,
      "variation": value.variation,
      "currency": value.currency,
      "quantity": value.quantity,
      "marketingcloudpid": value.marketingcloudpid,
      "variant_id": value.variantId,
  }
})}) :
eventPropertiesArray.push({id: "NbRKFviNt", name: "products_cart", value: null});
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProductsCartOptional(properties.productsCart));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "4l0ZskS226.zXISHUvOO", "304c30f3c99b022f3fdba199e815db6f001e06975fe8eaba78d51a127a329ffa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Loaded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("4l0ZskS226.zXISHUvOO", "Page Loaded", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Page Loaded': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  // destination Segment
  if (Segment.logPage) {
    Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface PromotionViewedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  promotionId: string;
  name: string;
  creative: CreativeValueType;
  position: number;
  ssMedium: string | null | undefined;
  ssSource: string | null | undefined;
  eventLabel: string | null | undefined;
  eventLocation: string | null | undefined;
}
/**
 * Promotion Viewed: When a promotion is being shown in the viewport 
Only add the 'products' object, if there are products in the promotion.

ss_source and ss_medium should only be filled for booking panel and SA panel

 * 
 * When to trigger this event:
 * 1. Journal - Support

promotion_name and id:
delivery-time-cost_support
returns-refunds_support
secure-payments_support
custommade-customizing_app
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/dmF0VfnHj
 * 2. Footer - Newsletter

promotion_id & name:
newsletter_campaign

Creative:
footer_link
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/9dwfTm8_b
 * 3. Lookbuilder - Shop the look

promotion id + name:
lookbuilder_app

creative: 
shop-the-look_panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/Do1oLQCdp
 * 4. Lookbuilder - wishlist

Promotion id + name:
lookbuilder_app

Creative:
panel_wishlist
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/XvOaPaSL_
 * 5. Lookbuilder - minicart

Promotion id + name:
lookbuilder_app

Creative:
panel_minicart
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/81fjlwsyo
 * 6. Lookbuilder - MWTW

Promotion id + name:
lookbuilder_app

Creative:
pdp_panel_mwtw
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/udZGnmpX6
 * 7. ﻿Lookbuilder - summary screen

Promotion id + name:
lookbuilder_app

Creative:
lookbuilder_summary
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/uqdx_UxpT
 * 8. creative: journal_adblock
promotion_id: black-tie-configurator-tuxedo_app
name: black-tie-configurator-tuxedo_app
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/wIqd9HpV3
 * 9. creative: clp_adblock
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/WmsGiomFq
 * 10. Creative: clp_buttonlink
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k/trigger/hqttb-Imb
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 

For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.creative: Name of location and type of the promotion
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.ssMedium: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns., should match regex: ^$|bt_panel|cs_panel
 * @param properties.ssSource: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns.

For store pages: ss_source: store_{{storename}}
For store experience pages: ss_source: journal_{{journal name with “-” between words}}
for store custommade near me: ss_source: journal_store_{{journal name with “-“ between words + store parameter in new landing pages}}
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k}
 */
export function promotionViewed(properties: PromotionViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
properties.ssMedium !== undefined && properties.ssMedium !== null ?
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: properties.ssMedium}) :
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: null});
properties.ssSource !== undefined && properties.ssSource !== null ?
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: properties.ssSource}) :
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
properties.eventLocation !== undefined && properties.eventLocation !== null ?
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPosition(properties.position));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Xo8CpcqD3k", "2d831b9d9ce0fe09c1c495824165621a8c070b432443f48bdf6063139975269a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promotion Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Xo8CpcqD3k", "Promotion Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Promotion Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Viewed", eventProperties, "Xo8CpcqD3k", "2d831b9d9ce0fe09c1c495824165621a8c070b432443f48bdf6063139975269a");
}
// destination Segment
Segment.logEvent("Promotion Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PromotionViewedShopTheLookSliderProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  promotionId: string;
  position: number;
  ssMedium: string | null | undefined;
  ssSource: string | null | undefined;
  eventLabel: string | null | undefined;
  creative: CreativeValueType;
  eventLocation: string | null | undefined;
}
/**
 * Promotion Viewed: When a promotion is being shown in the viewport 
Only add the 'products' object, if there are products in the promotion.

ss_source and ss_medium should only be filled for booking panel and SA panel, event variant
 * 
 * When to trigger this event:
 * 1. When the user view on a look from the 'Shop by Look' slider
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k.jI3EPQlflePYb6kEIAN8Q/trigger/IWJRZYvgaHcWuzNiog8jn
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 

For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.ssMedium: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns., should match regex: ^$|bt_panel|cs_panel
 * @param properties.ssSource: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns.

For store pages: ss_source: store_{{storename}}
For store experience pages: ss_source: journal_{{journal name with “-” between words}}
for store custommade near me: ss_source: journal_store_{{journal name with “-“ between words + store parameter in new landing pages}}
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.creative: Name of location and type of the promotion
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Xo8CpcqD3k.jI3EPQlflePYb6kEIAN8Q}
 */
export function promotionViewedShopTheLookSlider(properties: PromotionViewedShopTheLookSliderProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
properties.ssMedium !== undefined && properties.ssMedium !== null ?
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: properties.ssMedium}) :
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: null});
properties.ssSource !== undefined && properties.ssSource !== null ?
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: properties.ssSource}) :
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
properties.eventLocation !== undefined && properties.eventLocation !== null ?
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: "shop_the_look"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPosition(properties.position));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Xo8CpcqD3k.jI3EPQlflePYb6kEIAN8Q", "75ef14981b1c38ee94eb4161b4599a519d8adfddbdab889819e086f3cb234782", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promotion Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Xo8CpcqD3k.jI3EPQlflePYb6kEIAN8Q", "Promotion Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Promotion Viewed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Viewed", eventProperties, "Xo8CpcqD3k.jI3EPQlflePYb6kEIAN8Q", "75ef14981b1c38ee94eb4161b4599a519d8adfddbdab889819e086f3cb234782");
}
// destination Segment
Segment.logEvent("Promotion Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PromotionClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  promotionId: string;
  name: string;
  creative: CreativeValueType;
  position: number;
  ssMedium: string | null | undefined;
  ssSource: string | null | undefined;
  eventCategory: EventCategoryValueType;
}
/**
 * Promotion Clicked: When a promotion is clicked
Only add the 'products' object, if there are products in the promotion.

ss_source and ss_medium should only be filled for booking panel and SA panel
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 

For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.creative: Name of location and type of the promotion
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.ssMedium: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns., should match regex: ^$|bt_panel|cs_panel
 * @param properties.ssSource: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns.

For store pages: ss_source: store_{{storename}}
For store experience pages: ss_source: journal_{{journal name with “-” between words}}
for store custommade near me: ss_source: journal_store_{{journal name with “-“ between words + store parameter in new landing pages}}
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/lb-B8o9Lf}
 */
export function promotionClicked(properties: PromotionClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
properties.ssMedium !== undefined && properties.ssMedium !== null ?
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: properties.ssMedium}) :
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: null});
properties.ssSource !== undefined && properties.ssSource !== null ?
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: properties.ssSource}) :
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPosition(properties.position));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "lb-B8o9Lf", "89392bca09b36f285b427cccd00b9f3d0178d2d54b37915e697a7ee1d4d5037d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promotion Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("lb-B8o9Lf", "Promotion Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Promotion Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Clicked", eventProperties, "lb-B8o9Lf", "89392bca09b36f285b427cccd00b9f3d0178d2d54b37915e697a7ee1d4d5037d");
}
// destination Segment
Segment.logEvent("Promotion Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PromotionClickedShopTheLookSliderProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  promotionId: string;
  position: number;
  ssMedium: string | null | undefined;
  ssSource: string | null | undefined;
  eventLocation: string | null | undefined;
  creative: CreativeValueType;
}
/**
 * Promotion Clicked: When a promotion is clicked
Only add the 'products' object, if there are products in the promotion.

ss_source and ss_medium should only be filled for booking panel and SA panel, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks on a look from the 'Shop by Look' slider
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/lb-B8o9Lf.8_n9dAVVotvSqvf6xMObB/trigger/4xoPcP3TvKxzWuyqKfJX9
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.promotionId: This denotes a unique identifier for the promotion. 

For instance, in the case of 'Shop the Look,' the corresponding shop by look ID is: 1SW2054Summer1SW2054.
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.ssMedium: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns., should match regex: ^$|bt_panel|cs_panel
 * @param properties.ssSource: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns.

For store pages: ss_source: store_{{storename}}
For store experience pages: ss_source: journal_{{journal name with “-” between words}}
for store custommade near me: ss_source: journal_store_{{journal name with “-“ between words + store parameter in new landing pages}}
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.creative: Name of location and type of the promotion
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/lb-B8o9Lf.8_n9dAVVotvSqvf6xMObB}
 */
export function promotionClickedShopTheLookSlider(properties: PromotionClickedShopTheLookSliderProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "9zU3NBFWZ", name: "promotion_id", value: properties.promotionId});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
properties.ssMedium !== undefined && properties.ssMedium !== null ?
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: properties.ssMedium}) :
  eventPropertiesArray.push({id: "dCzQ_0RdM", name: "ss_medium", value: null});
properties.ssSource !== undefined && properties.ssSource !== null ?
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: properties.ssSource}) :
  eventPropertiesArray.push({id: "PBq0iEV4f", name: "ss_source", value: null});
properties.eventLocation !== undefined && properties.eventLocation !== null ?
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
eventPropertiesArray.push({id: "oFjan4Q_Q", name: "creative", value: properties.creative});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: "shop_the_look"});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPosition(properties.position));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "lb-B8o9Lf.8_n9dAVVotvSqvf6xMObB", "e2accb93fb51fb663dc053f50c7dfb8c555f85ddde6b515c5efa8e67786f1138", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Promotion Clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("lb-B8o9Lf.8_n9dAVVotvSqvf6xMObB", "Promotion Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Promotion Clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Clicked", eventProperties, "lb-B8o9Lf.8_n9dAVVotvSqvf6xMObB", "e2accb93fb51fb663dc053f50c7dfb8c555f85ddde6b515c5efa8e67786f1138");
}
// destination Segment
Segment.logEvent("Promotion Clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductAddedToWishlistProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * Product Added to Wishlist: When landing an a PDP and clicking the add to wishlist icon

For full looks, fire an add_to_wishlist event for every specific product.
 * 
 * When to trigger this event:
 * 1. When selecting the 'Add to Wishlist' icon.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/MoZcZa9Kt/trigger/21cyJ2qeD
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/MoZcZa9Kt}
 */
export function productAddedToWishlist(properties: ProductAddedToWishlistProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "MoZcZa9Kt", "a4eff7afddf12df1113e09c7da9e93ce8510e2b26ad2139d8846941bbc91d15b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added to Wishlist", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("MoZcZa9Kt", "Product Added to Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Added to Wishlist': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added to Wishlist", eventProperties, "MoZcZa9Kt", "a4eff7afddf12df1113e09c7da9e93ce8510e2b26ad2139d8846941bbc91d15b");
}
// destination Segment
Segment.logEvent("Product Added to Wishlist", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductAddedToWishlistOutOfStockProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  listId: string;
  itemListName: string;
  productId: string;
  category: string;
  itemCategory2: string;
  itemCategory3: string;
  itemCategory4: string;
  itemCategory5: string;
  affiliation: AffiliationValueType;
  name: string;
  variant: string;
  price: number;
  quantity: number;
  position: number;
  imageUrl: string;
  onlineMaterial: string | null | undefined;
  fitId: string | null | undefined;
  plpGridImages: string;
  shopTheLookId: string;
  cartId: string;
  mixAndMatch: MixAndMatchValueType;
  productSetId: string;
  sku: string;
  fullLook: string | null | undefined;
  value: number;
  eventLabel: string;
  outOfStock: boolean;
  eventLocation: string;
}
/**
 * Product Added to Wishlist: When landing an a PDP and clicking the add to wishlist icon

For full looks, fire an add_to_wishlist event for every specific product., variant description: This variant is designed to monitor products added to the wishlist that are currently out of stock. Consequently, we can utilize this event to segment users who have out-of-stock items in their wishlist and will be affected by back to stock notifications.
 * 
 * When to trigger this event:
 * 1. When the user clicks in "Add to Saved" on the out of stock item message
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/MoZcZa9Kt.ArNrE0Iib/trigger/woVdajZYlqN
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.listId: This property represents the List ID. Unlike the list name, the List ID is a more in-depth value that provides a more detailed understanding of the Product List Viewed.

For custom-made products, it's: custom-made.

For Shop the Look components:
1.  Shop the Look hero on PDP: `product_id` from the current PDP
2.  Shop the Look slider (MWTW) on PDP: `look_id`
3.  Shop the Look wishlist panel: `product_id` from the current PDP
4.  Shop the Look from minicart: `product_id` from the current PDP
5.  Shop the Look landing page: `look_id`
, should match regex: ^(|black-tie-package_(configurator|journal)|category_page|category_page_filtered|category-page-landing_(classic-suits|jackets-tuxedo|perennial-suits|shirts-tuxedo|suits-tuxedo|traveller-suits|tuxedo-suits|wedding-suits)|color-swatch_pdp|colour-swatch_pdp|custom-made|discover-our-collection_journal_(alter-your-fit|custom-made|the-hallmarks-of-a-quality-(shirt|shoe))|discover-the-new-collection_(csr-landing|newsletter-emailpreferences)|e\.thomas-collection_journal_e-thomas-mill|explore-the-collection_journal_(4-ply-traveller-collection|angelico-mill|candiani-mill|delfino-mill|drago-mill|fossati-mill|how-to-take-care-of-your-(knits|suits)|perennial-suits|reda-mill|reggiani-mill|relaxed-trousers-guide|weba-mill)|giftcard_landing|gift-wrapping_(cart|mini-cart)|most-popular_(store-detail|store-locator)|search|shop-(french-linen|indonesian-mother-of-pearl|the-look)_(journal_expedition-jort-the-tailoring-trail|custommade|lookbuilder_summary-screen|minicart|slider(_[1-7])?|wishlist)|view-similar-items_oos|wishlist|you-might-also-like_pdp)$
 * @param properties.itemListName: This property is the List Name. The list name should be a general name so that we can aggregate multiple list_id values under the same scope. For example, the Shop the Look slider contains multiple Product lists based on recommendations for each product. In this case, item_list_name is shop_the_look_mwtw and the list_id is the specific look_id. This allows us to aggregate the data from shop_the_look_mwtw on the item_list_name, while still having a detailed view on the list_id.


For custom-made
1. 'custom made'

For Shop the Look components:

1.  Shop the Look hero on PDP: shop_the_look_hero
2.  Shop the Look slider (MWTW) on PDP: shop_the_look_mwtw
3.  Shop the Look wishlist panel: shop_the_look_wishlist
4.  Shop the Look from minicart: shop_the_look_minicart
5.  Shop the Look landing page: shop_the_look_sbl
, should match regex: ^(|black tie package|category page|category page filtered|category page landing|color swatch|colour swatch|custom made|discover the new collection|explore the collection|gift wrapping|giftcard landing|most popular|search|shop the look|view similar items|wishlist|you might also like)$
 * @param properties.productId: SKU of product

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.itemCategory2: Product Category 2
 * @param properties.itemCategory3: Product Category 3
 * @param properties.itemCategory4: Product Category 4
 * @param properties.itemCategory5: Product Category
 * @param properties.affiliation: This should be webstore-{{currencycode lowercase}}
 * @param properties.name: Name of product as listed in Salesforce, english only, lowercase
Will be gift card for giftcard

for custommade:
trousers: dyo-trousers
jacket: dyo-jacket
waistcoat: dyo-waistcoat
coat: dyo-coat
shirt: dyo-shirt
 * @param properties.variant: Should return size for all products except giftcard. For Giftcard should return 'physical' or 'electronic', should match regex: ^(|5|6|6\.5|7|7\.5|8|8\.5|9|9\.5|10|10\.5|11|12|13|14|14\s1\/2|15|15\s1\/2|15\s3\/4|16|16\s1\/2|17|17\s1\/2|18|18\s1\/2|19|22|23|24|25|26|27|28|29|30|32|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|50|52|54|56|58|60|62|75|85|90|94|95|98|102|105|106|110|114|118|14\s1\/2s|15\s1\/2l|16l|17\s1\/2l|17\s3\/4l|17l|18\s1\/2s|29\/32|30\/32|30l|30s|31\/32|31\/34|32\/32|32\/34|32l|32s|33\/32|33\/34|34\/32|34\/34|34l|34s|35\/34|35\/36|36\/34|36l|36s|37\/38|37l|37s|38-7|38l|38s|39\/40|39-42|39-7|39l|39l\/40l|40-7|40l|40s|41\/42|41l|41l\/42l|42l|42s|43\/44|43-46|43l|43l\/44l|44l|44s|45\/46|46l|46s|47l|47s|48l|48s|52l|52s|56s|CustomMade|electronic|l|m|one-size|physical|s|xl|xs|xxl)$
 * @param properties.price: Price of single product
 * @param properties.quantity: Amount of products added/in to cart
 * @param properties.position: Position of product, should always start with 1.

Shop by look slider: This should represent which position in the slider. 
 * @param properties.imageUrl: URL of shown image/hero of product
Can sometimes be different from viewport url
 * @param properties.onlineMaterial: Material of product
 * @param properties.fitId: Describes the fit of the product, for example:
- havana
- milano
- roma
 * @param properties.plpGridImages: The view of the product on PLP, how many products per row, and how many pictures if 1 item is shown on a row., should match regex: ^(|1_product_default|1_product_with_[1-3]_images_default|2_products_default|2_products_grid|3_products_grid|4_products_grid)$
 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * @param properties.cartId: Cart ID of customer
 * @param properties.mixAndMatch: Should return 'true' or 'false' 
 * @param properties.productSetId: Product Set Id when product is mix and match
 * @param properties.sku: SKU of product, same as product_id
 * @param properties.fullLook: Send an additional variable that returns all the SKU's of the products when a full look is added to Wishlist (lookbuilder).
 * @param properties.value: Price * Quantity
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.outOfStock: This property indicates whether the item is out of stock. If the item is in stock, it should return: true. If the item is out of stock, it should return: false.
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/MoZcZa9Kt.ArNrE0Iib}
 */
export function productAddedToWishlistOutOfStock(properties: ProductAddedToWishlistOutOfStockProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "Ygy1AgJzJ", name: "list_id", value: properties.listId});
eventPropertiesArray.push({id: "6NzVmVGcY", name: "item_list_name", value: properties.itemListName});
eventPropertiesArray.push({id: "RmqMZ4ONr", name: "product_id", value: properties.productId});
eventPropertiesArray.push({id: "IiKR7dr0F", name: "category", value: properties.category});
eventPropertiesArray.push({id: "sQMBHWFY_", name: "item_category2", value: properties.itemCategory2});
eventPropertiesArray.push({id: "JieId3fKm", name: "item_category3", value: properties.itemCategory3});
eventPropertiesArray.push({id: "5vOpX9hBs", name: "item_category4", value: properties.itemCategory4});
eventPropertiesArray.push({id: "AtqbQIXpb", name: "item_category5", value: properties.itemCategory5});
eventPropertiesArray.push({id: "c5sqtMlHz", name: "affiliation", value: properties.affiliation});
eventPropertiesArray.push({id: "A8Oa9tHEe", name: "name", value: properties.name});
eventPropertiesArray.push({id: "rNNvglLqV", name: "variant", value: properties.variant});
eventPropertiesArray.push({id: "5RMsvPEmT", name: "price", value: properties.price});
eventPropertiesArray.push({id: "fg1kaNXr_", name: "quantity", value: properties.quantity});
eventPropertiesArray.push({id: "pBPbnpdFj", name: "position", value: properties.position});
eventPropertiesArray.push({id: "EmHDBRDoN", name: "image_url", value: properties.imageUrl});
properties.onlineMaterial !== undefined && properties.onlineMaterial !== null ?
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: properties.onlineMaterial}) :
  eventPropertiesArray.push({id: "h_-BHBawq", name: "online_material", value: null});
properties.fitId !== undefined && properties.fitId !== null ?
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: properties.fitId}) :
  eventPropertiesArray.push({id: "SfqMYUwv4", name: "fit_id", value: null});
eventPropertiesArray.push({id: "D8L1_0pcs", name: "plp_grid_images", value: properties.plpGridImages});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "14smmnfJh", name: "cart_id", value: properties.cartId});
eventPropertiesArray.push({id: "3YGdl5qO_", name: "mix_and_match", value: properties.mixAndMatch});
eventPropertiesArray.push({id: "kjpadIQOI", name: "product_set_id", value: properties.productSetId});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
properties.fullLook !== undefined && properties.fullLook !== null ?
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: properties.fullLook}) :
  eventPropertiesArray.push({id: "1Ull1Kol-", name: "full_look", value: null});
eventPropertiesArray.push({id: "Kddfsr3Xx", name: "value", value: properties.value});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "gHO_HPRSg", name: "out_of_stock", value: properties.outOfStock});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "cAQamFkP_", name: "brand", value: "suitsupply"});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: "ecommerce_interactions"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertPrice(properties.price));
  messages = messages.concat(assertQuantity(properties.quantity));
  messages = messages.concat(assertPosition(properties.position));
  messages = messages.concat(assertValue(properties.value));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "MoZcZa9Kt.ArNrE0Iib", "6aef7a7b0cea7ac7c10849e064baed396e1e165bfe9868a91a4be0936bf1b760", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Product Added to Wishlist", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("MoZcZa9Kt.ArNrE0Iib", "Product Added to Wishlist", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Product Added to Wishlist': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added to Wishlist", eventProperties, "MoZcZa9Kt.ArNrE0Iib", "6aef7a7b0cea7ac7c10849e064baed396e1e165bfe9868a91a4be0936bf1b760");
}
// destination Segment
Segment.logEvent("Product Added to Wishlist", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSizeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * select_size: When clicking the 'select size' button on PDP.

event_category:
If the event is happening on a journal page, the event_category will be plp_interactions, it's too much work for dev to create a specific journal_interactions.
For lookbuilder it will be lookbuilder_interactions


event_label: {{category}}_{{SKU}}

 * 
 * When to trigger this event:
 * 1. When clicking on the 'select size' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QZ8ruF0wR/trigger/K_ScJetAs
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QZ8ruF0wR}
 */
export function selectSize(properties: SelectSizeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QZ8ruF0wR", "33924ec40e14e79f5476a7c53ef725e3309dd3ae03f47be001c40f67ddf385c6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("select_size", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QZ8ruF0wR", "select_size", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_size", eventProperties, "QZ8ruF0wR", "33924ec40e14e79f5476a7c53ef725e3309dd3ae03f47be001c40f67ddf385c6");
}
// destination Segment
Segment.logEvent("select_size", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSizeSimilarProductsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * select_size: When clicking the 'select size' button on PDP.

event_category:
If the event is happening on a journal page, the event_category will be plp_interactions, it's too much work for dev to create a specific journal_interactions.
For lookbuilder it will be lookbuilder_interactions


event_label: {{category}}_{{SKU}}, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks on a product's "Select Size" button in the "Similar Products" list
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QZ8ruF0wR.eBZz_RwUK/trigger/_81MS6-1axF
 * 2. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QZ8ruF0wR.eBZz_RwUK/trigger/68xJMqJQDCp
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QZ8ruF0wR.eBZz_RwUK}
 */
export function selectSizeSimilarProducts(properties: SelectSizeSimilarProductsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QZ8ruF0wR.eBZz_RwUK", "3b6c16ee7346281d271263acdbfabd5f934187b333eb0307e255fad5f2a829e9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("select_size", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QZ8ruF0wR.eBZz_RwUK", "select_size", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_size", eventProperties, "QZ8ruF0wR.eBZz_RwUK", "3b6c16ee7346281d271263acdbfabd5f934187b333eb0307e255fad5f2a829e9");
}
// destination Segment
Segment.logEvent("select_size", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeChangedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  products: Products[];
}
/**
 * size_changed: When selecting a size in the size panel

event_label: {{category}}_{{SKU}}

event_category:
If the event is happening on a journal page, the event_category will be plp_interactions, it's too much work for dev to create a specific journal_interactions.
For lookbuilder it will be lookbuilder_interactions

 * 
 * When to trigger this event:
 * 1. When clicking on a size in the panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT/trigger/THklYHMK-
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.products: An array of products needed for the specific event
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT}
 */
export function sizeChanged(properties: SizeChangedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "FLODrHtrT", "0c12eb5e47c2b606c9a27b300afc5377f91f91fded7448b887da8b71f93cd679", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("FLODrHtrT", "size_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'size_changed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_changed", eventProperties, "FLODrHtrT", "0c12eb5e47c2b606c9a27b300afc5377f91f91fded7448b887da8b71f93cd679");
}
// destination Segment
Segment.logEvent("size_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeChangedSimilarProductsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  products: Products[];
}
/**
 * size_changed: When selecting a size in the size panel

event_label: {{category}}_{{SKU}}

event_category:
If the event is happening on a journal page, the event_category will be plp_interactions, it's too much work for dev to create a specific journal_interactions.
For lookbuilder it will be lookbuilder_interactions, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.products: An array of products needed for the specific event
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT.Y3pSQ6ZDs}
 */
export function sizeChangedSimilarProducts(properties: SizeChangedSimilarProductsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "similar_products_panel"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "FLODrHtrT.Y3pSQ6ZDs", "46d08dd0669fff21fb91dc357736a6e174d3f64c1f898d473b7bee2417eda258", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("FLODrHtrT.Y3pSQ6ZDs", "size_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'size_changed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_changed", eventProperties, "FLODrHtrT.Y3pSQ6ZDs", "46d08dd0669fff21fb91dc357736a6e174d3f64c1f898d473b7bee2417eda258");
}
// destination Segment
Segment.logEvent("size_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeChangedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  products: Products[];
  option: string;
  sku: string;
}
/**
 * size_changed: When selecting a size in the size panel

event_label: {{category}}_{{SKU}}

event_category:
If the event is happening on a journal page, the event_category will be plp_interactions, it's too much work for dev to create a specific journal_interactions.
For lookbuilder it will be lookbuilder_interactions, event variant
 * 
 * When to trigger this event:
 * 1. When the user selects a size in the "Select you size" panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH/trigger/iSkrkkk2-zIPe8uMBUojY
 * 2. When the user selects a size in the "Select you size" panel
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH/trigger/07uI9c7aDCZiTJhdGL99v
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.products: An array of products needed for the specific event
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH}
 */
export function sizeChangedBtc(properties: SizeChangedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH", "61b9cdd32735d399bcfc57e32cf87fa6e5cb7695b4762a60983f1f10d8ae7d6e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH", "size_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'size_changed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_changed", eventProperties, "FLODrHtrT.1jhIbXq0k-rFqmmOlzPGH", "61b9cdd32735d399bcfc57e32cf87fa6e5cb7695b4762a60983f1f10d8ae7d6e");
}
// destination Segment
Segment.logEvent("size_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CountryChangedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  newCountry: NewCountryValueType;
}
/**
 * country_changed: This event represents which country was selected by the user in the country selector tool. 

event_location: menu|pop-up|footer
 * 
 * When to trigger this event:
 * 1. When selecting a country
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/P8tUoYxJa/trigger/iAlBJNRHt
 * 2. When clicking on the change country button, in the pop up banner
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/P8tUoYxJa/trigger/XocwpVpmE
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.newCountry: This property indicates the country selected by the user when utilizing the country selector. Local country of website, ISO standard, lowercase
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/P8tUoYxJa}
 */
export function countryChanged(properties: CountryChangedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "F3nMZyXo6", name: "new_country", value: properties.newCountry});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "P8tUoYxJa", "e0ec0c91af5ba178a0a65252c1357489e3cb32a7a06bc0d8e26509db1f647d76", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("country_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("P8tUoYxJa", "country_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("country_changed", eventProperties, "P8tUoYxJa", "e0ec0c91af5ba178a0a65252c1357489e3cb32a7a06bc0d8e26509db1f647d76");
}
// destination Segment
Segment.logEvent("country_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LanguageChangedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  newLanguage: string;
}
/**
 * language_changed: This event is triggered when the user chooses a new language in the language selector

event_location: menu|pop-up|footer
 * 
 * When to trigger this event:
 * 1. When selecting a language
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/wv224noP0/trigger/dpnHqNIFZ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.newLanguage: This property specifies the language selected by the user in the language selector in ISO standard and presented in lowercase.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/wv224noP0}
 */
export function languageChanged(properties: LanguageChangedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "z1NzkpYs6", name: "new_language", value: properties.newLanguage});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "wv224noP0", "1807923aa65f6c130af2e363c7814c43acc860f51d4e78b58393c99848f3c7f9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("language_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("wv224noP0", "language_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("language_changed", eventProperties, "wv224noP0", "1807923aa65f6c130af2e363c7814c43acc860f51d4e78b58393c99848f3c7f9");
}
// destination Segment
Segment.logEvent("language_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HeaderAccountClickProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * header_account_click: When clicking on the account logo in the header. 
event_label: white|transparent
event_location: header
 * 
 * When to trigger this event:
 * 1. When clicking on the account logo in the header
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/u1i6ex4HW/trigger/c4TmbDce1
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/u1i6ex4HW}
 */
export function headerAccountClick(properties: HeaderAccountClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "u1i6ex4HW", "abf562a2ea94bc93cfc6647bf5ebb58b472be98ee778f334d92abd3a6f933f24", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("header_account_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("u1i6ex4HW", "header_account_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("header_account_click", eventProperties, "u1i6ex4HW", "abf562a2ea94bc93cfc6647bf5ebb58b472be98ee778f334d92abd3a6f933f24");
}
// destination Segment
Segment.logEvent("header_account_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HeaderLogoClickProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * header_logo_click: When clicking on the SuitSupply logo in the header. 
event_label: white|transparent
event_location: header
 * 
 * When to trigger this event:
 * 1. When clicking on the SuitSupply logo in the header
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vJwt-sKKq/trigger/evtGMEfPQ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vJwt-sKKq}
 */
export function headerLogoClick(properties: HeaderLogoClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vJwt-sKKq", "3def84663253569fedec0a438408b4c3a664da458eb59bce8dca30387f9afc2d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("header_logo_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vJwt-sKKq", "header_logo_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("header_logo_click", eventProperties, "vJwt-sKKq", "3def84663253569fedec0a438408b4c3a664da458eb59bce8dca30387f9afc2d");
}
// destination Segment
Segment.logEvent("header_logo_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ViewMinicartClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * view_minicart_clicked: When clicking on the minicart logo in the header. 
event_label: white|transparent
event_location: header
 * 
 * When to trigger this event:
 * 1. When the user clicks in the view cart but a side panel is shown
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Vzc7Bw6Sp/trigger/h7rOthP_C6c7LYLfuRWkn
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/Vzc7Bw6Sp}
 */
export function viewMinicartClicked(properties: ViewMinicartClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Vzc7Bw6Sp", "f22af7368b53dcb168c716ee7e26eb6593cde2f5f205c2695384a73a66ab5d71", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("view_minicart_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Vzc7Bw6Sp", "view_minicart_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_minicart_clicked", eventProperties, "Vzc7Bw6Sp", "f22af7368b53dcb168c716ee7e26eb6593cde2f5f205c2695384a73a66ab5d71");
}
// destination Segment
Segment.logEvent("view_minicart_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HeaderWishlistClickProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * header_wishlist_click: When clicking on the wishlist logo in the header. 
event_label: white|transparent
event_location: header
 * 
 * When to trigger this event:
 * 1. When clicking on the wishlist logo in the header
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/1Rx8sEaGk/trigger/1_A8oMR5X
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/1Rx8sEaGk}
 */
export function headerWishlistClick(properties: HeaderWishlistClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "1Rx8sEaGk", "3acdca5a20ca1dd606a7c8853b22c7cf4f087badec681bd1cd8c8a3d281dccea", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("header_wishlist_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("1Rx8sEaGk", "header_wishlist_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("header_wishlist_click", eventProperties, "1Rx8sEaGk", "3acdca5a20ca1dd606a7c8853b22c7cf4f087badec681bd1cd8c8a3d281dccea");
}
// destination Segment
Segment.logEvent("header_wishlist_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface MenuClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  layer: number;
  menuId: string;
  parentId: string | null | undefined;
}
/**
 * menu_clicked: This event represents a click in the menu, where the layer property represents which layer  link it was clicked. 

The menu icon layer value is always 0, and it should be the only item assigned this value. The subsequent layers are 1, 2, depending on the level at which the menu item is presented.

 * 
 * When to trigger this event:
 * 1. When clicking an item in the menu
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/q034uYqya/trigger/dTt9M_KVq
 * 2. Event triggered when the user selects a menu option.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/q034uYqya/trigger/Y_m2PNzEya
 * 3. Event triggered when the user selects a menu option.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/q034uYqya/trigger/Ri0mvRRuP
 * 4. Event triggered when the user clicks the menu icon to open the menu.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/q034uYqya/trigger/qnCP5HghFr
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.layer: This property defines the layer on which the menu item is displayed. The menu icon layer value is always 0, and it should be the only item assigned this value. The subsequent layers are 1, 2, depending on the level at which the menu item is presented.
 * @param properties.menuId: This property indicates the menu item with which the user interacted. The value must be in lowercase and separated by underscores. For example, 'New Arrivals' should be formatted as 'new_arrivals.'

For the initial hamburger menu we can call it 'hamburger' 
 * @param properties.parentId: This property describes the parent menu of the clicked item. This allows us to differentiate between clicking 'Tuxedos' within the 'Clothing' menu versus clicking it within 'Occasions.'
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/q034uYqya}
 */
export function menuClicked(properties: MenuClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "AP8YaoiZD", name: "layer", value: properties.layer});
eventPropertiesArray.push({id: "nUFM6sxzT", name: "menu_id", value: properties.menuId});
properties.parentId !== undefined && properties.parentId !== null ?
  eventPropertiesArray.push({id: "CxIb8_MvbWbgXoRqBY_e6", name: "parent_id", value: properties.parentId}) :
  eventPropertiesArray.push({id: "CxIb8_MvbWbgXoRqBY_e6", name: "parent_id", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "q034uYqya", "c4b6bfb0e7215116743113055691a41319b32a0eea1c4d6187ca8ddf7e0a2350", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("menu_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("q034uYqya", "menu_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("menu_clicked", eventProperties, "q034uYqya", "c4b6bfb0e7215116743113055691a41319b32a0eea1c4d6187ca8ddf7e0a2350");
}
// destination Segment
Segment.logEvent("menu_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface FooterClickProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * footer_click: When a link is clicked in the footer.

event_label: {{last path url}} example: returns-refunds.html|suits.  
for socials: facebook|tiktok|youtube|instagram
for contact: whatsapp|phone|email|wechat
for China: wechat-qr-official|wechat-miniprogram|weibo|https://www.beian.miit.gov.cn/
 * 
 * When to trigger this event:
 * 1. When clicking a link in the footer
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/8E2-KsTj0l/trigger/Pf0yTDV5q
 * 2. When clicking on the social icons
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/8E2-KsTj0l/trigger/HkHP6k1jC
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/8E2-KsTj0l}
 */
export function footerClick(properties: FooterClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "8E2-KsTj0l", "69237b06e053b83ce59a79c2d61ed9ff54ccc76e755e95bb19f4c381a33ef7a7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("footer_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("8E2-KsTj0l", "footer_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("footer_click", eventProperties, "8E2-KsTj0l", "69237b06e053b83ce59a79c2d61ed9ff54ccc76e755e95bb19f4c381a33ef7a7");
}
// destination Segment
Segment.logEvent("footer_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface NewsletterSubscribeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * newsletter_subscribe: When clicking on the subscribe to email button

event_label: email_verified|email_error_{{error message}}
 * 
 * When to trigger this event:
 * 1. When clicking on the subscribe button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_M87doXAKz/trigger/5xFgRsIGI
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_M87doXAKz}
 */
export function newsletterSubscribe(properties: NewsletterSubscribeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "_M87doXAKz", "849c2e6dec990fd04221e133516e003fff83cd1c2c228d1ba9713938055879d5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("newsletter_subscribe", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("_M87doXAKz", "newsletter_subscribe", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("newsletter_subscribe", eventProperties, "_M87doXAKz", "849c2e6dec990fd04221e133516e003fff83cd1c2c228d1ba9713938055879d5");
}
// destination Segment
Segment.logEvent("newsletter_subscribe", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface FabricOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * fabric_option_select: Firing when the fabric option is clicked.

- cm_option: {{clicked fabric group}}_{{clicked color code}} example: most-popular_black-pure-s110s-wool|black_black-wool-stretch

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a fabric is selected
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/yhrlHOrZQ/trigger/5QvaRyd3N
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/yhrlHOrZQ}
 */
export function fabricOptionSelect(properties: FabricOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yhrlHOrZQ", "81c252cfb30218b5c7912bb660afaf9cdb89bead510d137ae9ba80443edb410f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("fabric_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yhrlHOrZQ", "fabric_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_option_select", eventProperties, "yhrlHOrZQ", "81c252cfb30218b5c7912bb660afaf9cdb89bead510d137ae9ba80443edb410f");
}
// destination Segment
Segment.logEvent("fabric_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface FabricOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * fabric_option_confirm: Firing when the fabric option is confirmed.

- cm_option: {{clicked fabric group}}_{{clicked color code}} example: most-popular_black-pure-s110s-wool|black_black-wool-stretch

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a fabric option is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kCtNIDRn2/trigger/dIhRahME5
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/kCtNIDRn2}
 */
export function fabricOptionConfirm(properties: FabricOptionConfirmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "kCtNIDRn2", "9c4a6704681dca6a53ac3b7a0f9ba4131b293f4f260390abf08cc0c1d7fd22b1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("fabric_option_confirm", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("kCtNIDRn2", "fabric_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("fabric_option_confirm", eventProperties, "kCtNIDRn2", "9c4a6704681dca6a53ac3b7a0f9ba4131b293f4f260390abf08cc0c1d7fd22b1");
}
// destination Segment
Segment.logEvent("fabric_option_confirm", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string | null | undefined;
}
/**
 * style_option_select: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a style is selected.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eRtiLrwzB/trigger/r-pdwSlnh
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eRtiLrwzB}
 */
export function styleOptionSelect(properties: StyleOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.btcOption !== undefined && properties.btcOption !== null ?
  eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption}) :
  eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eRtiLrwzB", "196e564823ef44294689ea0bcaac257f54f398a87a8173a5d25f54ec14f3d726", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eRtiLrwzB", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB", "196e564823ef44294689ea0bcaac257f54f398a87a8173a5d25f54ec14f3d726");
}
// destination Segment
Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionSelectBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string | null | undefined;
}
/**
 * style_option_select: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket, variant description: When selecting a style (two-piece or three-piece)

btc_option: two-piece|three-piece
event_location: btc_suits
 * 
 * When to trigger this event:
 * 1. When selecting a style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eRtiLrwzB.icAnSf8FR/trigger/Eofccc3se
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eRtiLrwzB.icAnSf8FR}
 */
export function styleOptionSelectBtc(properties: StyleOptionSelectBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.btcOption !== undefined && properties.btcOption !== null ?
  eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption}) :
  eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eRtiLrwzB.icAnSf8FR", "3c2c009754af4a7eeb8339af1e4c911d6b2edafd1d4b57cdd5025abe5544d9e9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eRtiLrwzB.icAnSf8FR", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB.icAnSf8FR", "3c2c009754af4a7eeb8339af1e4c911d6b2edafd1d4b57cdd5025abe5544d9e9");
}
// destination Segment
Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionSelectCmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * style_option_select: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eRtiLrwzB.pxxFF_WKY}
 */
export function styleOptionSelectCm(properties: StyleOptionSelectCmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eRtiLrwzB.pxxFF_WKY", "d4ffde1c3e97d68eb28cbd632c25dd547ce30c590e088443d74cabbd2b1a17da", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eRtiLrwzB.pxxFF_WKY", "style_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_select", eventProperties, "eRtiLrwzB.pxxFF_WKY", "d4ffde1c3e97d68eb28cbd632c25dd547ce30c590e088443d74cabbd2b1a17da");
}
// destination Segment
Segment.logEvent("style_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * style_option_confirm: Firing when the style option is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When a style is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/yhBSr917Q/trigger/BXyfxriJU
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/yhBSr917Q}
 */
export function styleOptionConfirm(properties: StyleOptionConfirmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yhBSr917Q", "37c5a0d3db1760b3d44b411e79c98815d7d1460a59e8fd2efcf846b691cb2575", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_confirm", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yhBSr917Q", "style_option_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_confirm", eventProperties, "yhBSr917Q", "37c5a0d3db1760b3d44b411e79c98815d7d1460a59e8fd2efcf846b691cb2575");
}
// destination Segment
Segment.logEvent("style_option_confirm", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SummaryEditProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * summary_edit: When clicking on 'edit' icon on the summary screen 

- event_location: cm_{{category}}_summaryexample cm_suits_summary
- cm_option: jacket|trousers|waistcoat

 * 
 * When to trigger this event:
 * 1. When clicking on 'edit' icon on the summary screen 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/KNnHKBbfV/trigger/-TISpFDBA
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/KNnHKBbfV}
 */
export function summaryEdit(properties: SummaryEditProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "KNnHKBbfV", "a683573f394bc12cfa3b05799b9561d9ce14610e5741cfa420f1833dc145168f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("summary_edit", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("KNnHKBbfV", "summary_edit", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_edit", eventProperties, "KNnHKBbfV", "a683573f394bc12cfa3b05799b9561d9ce14610e5741cfa420f1833dc145168f");
}
// destination Segment
Segment.logEvent("summary_edit", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionChangeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * style_option_change: Firing when the style change/edit is selected.

- cm_option:{{selected option}} example: business|casual|classic-double-breasted

- event_location: {{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is clicked.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/RxyJeDhDH/trigger/18NhXj3B6
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/RxyJeDhDH}
 */
export function styleOptionChange(properties: StyleOptionChangeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "RxyJeDhDH", "f6a9b5fb1ed7a9c2d1fa06ac7afcf2bdc5b0350a0816582817dac526386d6028", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_change", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("RxyJeDhDH", "style_option_change", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change", eventProperties, "RxyJeDhDH", "f6a9b5fb1ed7a9c2d1fa06ac7afcf2bdc5b0350a0816582817dac526386d6028");
}
// destination Segment
Segment.logEvent("style_option_change", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionChangeConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * style_option_change_confirm: Firing when the pop up 'change style' is clicked.

- cm_option: {{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is confirmed.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/EvgoQxQSE/trigger/R0LLZPLto
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/EvgoQxQSE}
 */
export function styleOptionChangeConfirm(properties: StyleOptionChangeConfirmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "EvgoQxQSE", "090fafaf7ad8691e0d9a8baa39be1a831370edee158d513f96838d5a61aeda3c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_change_confirm", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("EvgoQxQSE", "style_option_change_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change_confirm", eventProperties, "EvgoQxQSE", "090fafaf7ad8691e0d9a8baa39be1a831370edee158d513f96838d5a61aeda3c");
}
// destination Segment
Segment.logEvent("style_option_change_confirm", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface StyleOptionChangeCancelProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  cmOption: string | null | undefined;
}
/**
 * style_option_change_cancel: Firing when the pop up 'change style' is cancelled.

- cm_option: {{selected option}} example: business|casual|classic-double-breasted

- event_location: cm_{{category}}_{{subcategory}} example: cm_suits_jacket
 * 
 * When to trigger this event:
 * 1. When the option to change the style is cancelled.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/viJG3zwB_/trigger/cAfAKMRSv
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.cmOption: Describes which option was selected, and which outcome was chosen
Description is added in the event.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/viJG3zwB_}
 */
export function styleOptionChangeCancel(properties: StyleOptionChangeCancelProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
properties.cmOption !== undefined && properties.cmOption !== null ?
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: properties.cmOption}) :
  eventPropertiesArray.push({id: "PAXuVgcO0", name: "cm_option", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "viJG3zwB_", "0163771bb837b0bc2a40bec669d436ac102142ce8313fcb54fe99dce7193df00", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("style_option_change_cancel", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("viJG3zwB_", "style_option_change_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("style_option_change_cancel", eventProperties, "viJG3zwB_", "0163771bb837b0bc2a40bec669d436ac102142ce8313fcb54fe99dce7193df00");
}
// destination Segment
Segment.logEvent("style_option_change_cancel", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface JacketOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * jacket_option_select: When selecting a fabric (black-wool|black-velvet|navy-wool)

btc_option: black-wool|black-velvet|navy-wool
event_location: btc_suits_jacket|btc_suits_trousers|btc_suits_shirt
 * 
 * When to trigger this event:
 * 1. When selecting a fabric
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/EU5N_T3DG/trigger/N8UFDe0Os
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/EU5N_T3DG}
 */
export function jacketOptionSelect(properties: JacketOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "EU5N_T3DG", "7096b2b6fcce2432ed802a03dfac2e9afdc5175ffc28cc8dd23cdd4f559e016c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("jacket_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("EU5N_T3DG", "jacket_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("jacket_option_select", eventProperties, "EU5N_T3DG", "7096b2b6fcce2432ed802a03dfac2e9afdc5175ffc28cc8dd23cdd4f559e016c");
}
// destination Segment
Segment.logEvent("jacket_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ShirtOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * shirt_option_select: When selecting a shirt (pleated-bib|hidden-placket|pique-bib)

btc_option: {{SKU}}
event_location: btc_suits_shirt
 * 
 * When to trigger this event:
 * 1. When selecting a shirt 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/ppI--NzO5/trigger/Q4NPkIiob
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/ppI--NzO5}
 */
export function shirtOptionSelect(properties: ShirtOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ppI--NzO5", "ecb6702132e1cce7606a7a36fa018cc6a494dffe79918744101e0d909ec51b81", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("shirt_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ppI--NzO5", "shirt_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("shirt_option_select", eventProperties, "ppI--NzO5", "ecb6702132e1cce7606a7a36fa018cc6a494dffe79918744101e0d909ec51b81");
}
// destination Segment
Segment.logEvent("shirt_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ShoesOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * shoes_option_select: When selecting a shoe (leather-oxford|velvet-slip-on)

btc_option: {{SKU}}
event_location: btc_suits_shoes
 * 
 * When to trigger this event:
 * 1. When selecting a shoe style
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/dun37FtuD/trigger/RtTovP3s0
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/dun37FtuD}
 */
export function shoesOptionSelect(properties: ShoesOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "dun37FtuD", "0e57bf67f6654fb82862ee66e599afbba1cbed895b3f2d1d2ebb26a999d4fe47", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("shoes_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("dun37FtuD", "shoes_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("shoes_option_select", eventProperties, "dun37FtuD", "0e57bf67f6654fb82862ee66e599afbba1cbed895b3f2d1d2ebb26a999d4fe47");
}
// destination Segment
Segment.logEvent("shoes_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface BowtieOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string | null | undefined;
  btcOption: string;
}
/**
 * bowtie_option_select: When selecting a bow-tie (black-self-tied)

When confirming a bowtie (black-self-tied)
btc_option isn't name in this case since a lot of bowties have the same name (for example Black Self-Tied, therefor we use the SKU in the btc_option

btc_option: {{SKU}}
event_location: btc_suits_bow-tie
 * 
 * When to trigger this event:
 * 1. When selecting a bowtie 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/2yi_RMQ3b/trigger/BpZWZq_qj
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/2yi_RMQ3b}
 */
export function bowtieOptionSelect(properties: BowtieOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
properties.eventLocation !== undefined && properties.eventLocation !== null ?
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "2yi_RMQ3b", "9bd3714b63d6408bbfd48b2c64d13e7bb17ab0358da83a41ff42c1e0c81fd3c4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("bowtie_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("2yi_RMQ3b", "bowtie_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("bowtie_option_select", eventProperties, "2yi_RMQ3b", "9bd3714b63d6408bbfd48b2c64d13e7bb17ab0358da83a41ff42c1e0c81fd3c4");
}
// destination Segment
Segment.logEvent("bowtie_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CufflinkOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * cufflink_option_select: When selecting a cufflink

btc_option isn't the name in this case since a lot of cufflinks have the same name (for example Silver round or Gold round), therefor we use the SKU in the btc_option

btc_option: {{SKU}}
event_location: btc_suits_cufflinks
 * 
 * When to trigger this event:
 * 1. When selecting a cufflink 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/RkRz_Hj16/trigger/zInO1Vapu
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/RkRz_Hj16}
 */
export function cufflinkOptionSelect(properties: CufflinkOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "RkRz_Hj16", "101807e8548029289a27044d2419baf0acb69ad6469d8837f113dc26be5371b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("cufflink_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("RkRz_Hj16", "cufflink_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cufflink_option_select", eventProperties, "RkRz_Hj16", "101807e8548029289a27044d2419baf0acb69ad6469d8837f113dc26be5371b4");
}
// destination Segment
Segment.logEvent("cufflink_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SuspendersOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * suspenders_option_select: When selecting suspenders

btc_option: {{SKU}}
event_location: btc_suits_suspenders
 * 
 * When to trigger this event:
 * 1. When selecting suspenders 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DZOC-lBrn/trigger/fS2cf2hM1
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DZOC-lBrn}
 */
export function suspendersOptionSelect(properties: SuspendersOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "DZOC-lBrn", "ebee44958c6a0e1432f0d0332818f8ce994cc7ba170752c5327a67591d0270eb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("suspenders_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("DZOC-lBrn", "suspenders_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("suspenders_option_select", eventProperties, "DZOC-lBrn", "ebee44958c6a0e1432f0d0332818f8ce994cc7ba170752c5327a67591d0270eb");
}
// destination Segment
Segment.logEvent("suspenders_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface BtcSummaryEditProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * btc_summary_edit: When clicking 'edit' icon on summary screen

event_location: btc_summary_{{category} example: btc_summary_jacket
 * 
 * When to trigger this event:
 * 1. When clicking on 'edit' icon on summary screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4RLb03h05/trigger/Fye-Jl3tu
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/4RLb03h05}
 */
export function btcSummaryEdit(properties: BtcSummaryEditProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "4RLb03h05", "db2c95cdfb6f5ba45697f560e5f4c947f47140b9c8036eaba298a74d4e9a0ae2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("btc_summary_edit", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("4RLb03h05", "btc_summary_edit", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("btc_summary_edit", eventProperties, "4RLb03h05", "db2c95cdfb6f5ba45697f560e5f4c947f47140b9c8036eaba298a74d4e9a0ae2");
}
// destination Segment
Segment.logEvent("btc_summary_edit", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PreviousStepProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * previous_step: when clicking on previous arrow in BTC configurator
event_category: btc_interactions
event_location: btc_{{category}}_{{subcategory}} example: btc_suits_jacket_lapel
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/nIjDUsmcwn/trigger/ySRM6FVek
 * 2. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/nIjDUsmcwn/trigger/Cq9EZLjcQ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/nIjDUsmcwn}
 */
export function previousStep(properties: PreviousStepProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "nIjDUsmcwn", "23bbc6c7b847e0e251d182b6b06984d885931571da5c3a457a4cd3b1e0c00781", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("previous_step", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("nIjDUsmcwn", "previous_step", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("previous_step", eventProperties, "nIjDUsmcwn", "23bbc6c7b847e0e251d182b6b06984d885931571da5c3a457a4cd3b1e0c00781");
}
// destination Segment
Segment.logEvent("previous_step", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface NextStepProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * next_step: when clicking on next arrow in BTC configurator
event_category: btc_interactions
event_location: btc_{{category}}_{{subcategory}} example: btc_suits_jacket_lapel
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/7pxnr-tZL/trigger/y1wt8zRXy
 * 2. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/7pxnr-tZL/trigger/5OS5ilICD
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/7pxnr-tZL}
 */
export function nextStep(properties: NextStepProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "7pxnr-tZL", "621596c6fd79d3e9723fe5ab213e3bcd2a49a27feb265a974443b2bde059d95f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("next_step", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("7pxnr-tZL", "next_step", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("next_step", eventProperties, "7pxnr-tZL", "621596c6fd79d3e9723fe5ab213e3bcd2a49a27feb265a974443b2bde059d95f");
}
// destination Segment
Segment.logEvent("next_step", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeGuideClickProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * size_guide_click: When clicking on the 'size guide' button

btc_option: {{SKU}}
event_location: example: btc_suits_shirt
 * 
 * When to trigger this event:
 * 1. When clicking 'Size guide' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/-AnVCYt0T/trigger/xC8kgIxIk
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/-AnVCYt0T}
 */
export function sizeGuideClick(properties: SizeGuideClickProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "-AnVCYt0T", "0b8d7e768f0ff5a3a52ce37be2c496eb774e0131d48eef2aef1e2723a0116532", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_guide_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("-AnVCYt0T", "size_guide_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_guide_click", eventProperties, "-AnVCYt0T", "0b8d7e768f0ff5a3a52ce37be2c496eb774e0131d48eef2aef1e2723a0116532");
}
// destination Segment
Segment.logEvent("size_guide_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeGuideClickSimilarProductsProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  btcOption: string;
}
/**
 * size_guide_click: When clicking on the 'size guide' button

btc_option: {{SKU}}
event_location: example: btc_suits_shirt, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/-AnVCYt0T.eMbOY6NgQ}
 */
export function sizeGuideClickSimilarProducts(properties: SizeGuideClickSimilarProductsProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: "similar_products_panel"});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "-AnVCYt0T.eMbOY6NgQ", "c801cf8faba63a69a558688505f72f6e051b414219eb68a9ece7c62fa7b7f0ee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_guide_click", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("-AnVCYt0T.eMbOY6NgQ", "size_guide_click", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_guide_click", eventProperties, "-AnVCYt0T.eMbOY6NgQ", "c801cf8faba63a69a558688505f72f6e051b414219eb68a9ece7c62fa7b7f0ee");
}
// destination Segment
Segment.logEvent("size_guide_click", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeConfirmProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * size_confirm: When clicking on the 'confirm' button

btc_option: {{SKU}}
event_location: example: btc_suits_shirt
 * 
 * When to trigger this event:
 * 1. When clicking 'confirm' button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/y80nFRNre/trigger/YUSb5ZlpJ
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/y80nFRNre}
 */
export function sizeConfirm(properties: SizeConfirmProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "y80nFRNre", "413f0d3d7758521f5ee9c43919351987f38eb23fa5d326dfc07064f1563ab9dd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_confirm", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("y80nFRNre", "size_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_confirm", eventProperties, "y80nFRNre", "413f0d3d7758521f5ee9c43919351987f38eb23fa5d326dfc07064f1563ab9dd");
}
// destination Segment
Segment.logEvent("size_confirm", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TrousersOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * trousers_option_select: When selecting a fabric (black-wool|black-velvet|navy-wool)

btc_option: black-wool|black-velvet|navy-wool
event_location: btc_suits_jacket|btc_suits_trousers|btc_suits_shirt
 * 
 * When to trigger this event:
 * 1. When selecting a fabric
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/CqpdLZEyR/trigger/yzkz_8B1U0
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/CqpdLZEyR}
 */
export function trousersOptionSelect(properties: TrousersOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "CqpdLZEyR", "8e8c7de9220063569a5dd81e61002f6649b822efe2b1ca91fd58c0bf3e93d0e4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("trousers_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("CqpdLZEyR", "trousers_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("trousers_option_select", eventProperties, "CqpdLZEyR", "8e8c7de9220063569a5dd81e61002f6649b822efe2b1ca91fd58c0bf3e93d0e4");
}
// destination Segment
Segment.logEvent("trousers_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface WaistcoatOptionSelectProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  btcOption: string;
}
/**
 * waistcoat_option_select: When selecting a fabric (black-wool|black-velvet|navy-wool)

btc_option: without_waistcoat|add_waistcoat
event_location: btc_suits_waistcoat
 * 
 * When to trigger this event:
 * 1. When selecting a waistcoat
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vYvR050eC/trigger/n2_XXZLKL4
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.btcOption: This property represents the choice made by the user on the black tie configurator. This property is being changed to the 'option' property. 
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vYvR050eC}
 */
export function waistcoatOptionSelect(properties: WaistcoatOptionSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "bEtCdP6Ew", name: "btc_option", value: properties.btcOption});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vYvR050eC", "086c390ab1a442589c3a6965cd2679b7242724ec68df532584aa74f0d5254491", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("waistcoat_option_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vYvR050eC", "waistcoat_option_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("waistcoat_option_select", eventProperties, "vYvR050eC", "086c390ab1a442589c3a6965cd2679b7242724ec68df532584aa74f0d5254491");
}
// destination Segment
Segment.logEvent("waistcoat_option_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LookChangedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  shopTheLookId: string;
}
/**
 * look_changed: This event represent an user interaction with the arrows to changes looks in the Shop By Look page
 * 
 * When to trigger this event:
 * 1. This event is trigger every time that the user interacts with the arrows in the Shop By Look page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/PsdfXG3Fkca/trigger/-BU9YWosZH
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.shopTheLookId: This describes the shop the look id, if available
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/PsdfXG3Fkca}
 */
export function lookChanged(properties: LookChangedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "vPAMuxU06", name: "shop_the_look_id", value: properties.shopTheLookId});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "PsdfXG3Fkca", "1a5316abb43a48a18c72765d2181db48095efc336e7fc8e23b3835f49c3f34c2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("look_changed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("PsdfXG3Fkca", "look_changed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("look_changed", eventProperties, "PsdfXG3Fkca", "1a5316abb43a48a18c72765d2181db48095efc336e7fc8e23b3835f49c3f34c2");
}
// destination Segment
Segment.logEvent("look_changed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OptionSelectedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * option_selected: This event is fired when the user clicks on an option within a step in the configurator so we can see how many times the user change the options before confirming to the next step. 
option: {{SKU}}
event_location: btc_suits_bow-tie {{to be confirmed}}


-----
btc_option isn't name in this case since a lot of bowties have the same name (for example Black Self-Tied, therefor we use the SKU in the btc_option

 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I}
 */
export function optionSelected(properties: OptionSelectedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vppBK1T0M_I", "901f490c8d592ac9e48f2f3e188dbc7f32f4e5e347a17e72e5000e98e37cc4f6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("option_selected", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vppBK1T0M_I", "option_selected", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("option_selected", eventProperties, "vppBK1T0M_I", "901f490c8d592ac9e48f2f3e188dbc7f32f4e5e347a17e72e5000e98e37cc4f6");
}
// destination Segment
Segment.logEvent("option_selected", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OptionSelectedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * option_selected: This event is fired when the user clicks on an option within a step in the configurator so we can see how many times the user change the options before confirming to the next step. 
option: {{SKU}}
event_location: btc_suits_bow-tie {{to be confirmed}}


-----
btc_option isn't name in this case since a lot of bowties have the same name (for example Black Self-Tied, therefor we use the SKU in the btc_option, variant description: This event is fired when the user clicks on an option within a step in the configurator so we can see how many times the user change the options before confirming to the next step. option: {{SKU}} event_location: btc_suits_bow-tie {{to be confirmed}} ----- btc_option isn't name in this case since a lot of bowties have the same name (for example Black Self-Tied, therefor we use the SKU in the btc_option
 * 
 * When to trigger this event:
 * 1. When the user clicks in one of the option within a step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/sVVlgA2qVRw
 * 2. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/HKWMVmK6m8K
 * 3. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/vET8iJLpeU
 * 4. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/dVPACtEd0
 * 5. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/s_16XADUm
 * 6. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/fvw4P-BbJ
 * 7. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/wb8ft9dBA
 * 8. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/cVs9t2flF
 * 9. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/0DhEOcUxI
 * 10. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/MnK9yn87s
 * 11. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/0NQOcdYKD
 * 12. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/ES5PVCJRA
 * 13. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/VOiFvJC9U
 * 14. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/foJRkY2fN
 * 15. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/8thrDztx9
 * 16. When the user selects an option within the step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8/trigger/XtjhaL_eZjj
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/vppBK1T0M_I.EncCALhG8}
 */
export function optionSelectedBtc(properties: OptionSelectedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vppBK1T0M_I.EncCALhG8", "3afbbd8e47023c97a86e247914b9afd67f7ac15a301dc2186f70f7bfe74206e2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("option_selected", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vppBK1T0M_I.EncCALhG8", "option_selected", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("option_selected", eventProperties, "vppBK1T0M_I.EncCALhG8", "3afbbd8e47023c97a86e247914b9afd67f7ac15a301dc2186f70f7bfe74206e2");
}
// destination Segment
Segment.logEvent("option_selected", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OptionConfirmedProperties {
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
}
/**
 * option_confirmed: This event is triggered when the user clicks the "Next" button within a step of the configurator, allowing us to track which item the user selected.
 * 
 * @param properties the properties associatied with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/s6fGh_GONGm}
 */
export function optionConfirmed(properties: OptionConfirmedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "s6fGh_GONGm", "666d7d8bd0bcd3efaa790cf5127a1d0edfbace5ea0e6d59bb99d409185102414", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("option_confirmed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("s6fGh_GONGm", "option_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("option_confirmed", eventProperties, "s6fGh_GONGm", "666d7d8bd0bcd3efaa790cf5127a1d0edfbace5ea0e6d59bb99d409185102414");
}
// destination Segment
Segment.logEvent("option_confirmed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OptionConfirmedBtcProperties {
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  option: string;
  sku: string;
}
/**
 * option_confirmed: This event is triggered when the user clicks the "Next" button within a step of the configurator, allowing us to track which item the user selected., event variant
 * 
 * When to trigger this event:
 * 1. This event represents user interactions with the options displayed in the configurator. It is utilized to monitor which option the user has selected
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/s6fGh_GONGm.I9Ip6pAwO/trigger/N4It_Notb6b
 * 2. This event represents user interactions with the options displayed in the configurator. It is utilized to monitor which option the user has selected
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/s6fGh_GONGm.I9Ip6pAwO/trigger/OPvnf1lMF
 * 
 * @param properties the properties associatied with this event
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/s6fGh_GONGm.I9Ip6pAwO}
 */
export function optionConfirmedBtc(properties: OptionConfirmedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "s6fGh_GONGm.I9Ip6pAwO", "2e5055c74ad0907fe0f2354ea9e8fc40561a7efa8b3042000e04aa4caf8b4c16", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("option_confirmed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("s6fGh_GONGm.I9Ip6pAwO", "option_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("option_confirmed", eventProperties, "s6fGh_GONGm.I9Ip6pAwO", "2e5055c74ad0907fe0f2354ea9e8fc40561a7efa8b3042000e04aa4caf8b4c16");
}
// destination Segment
Segment.logEvent("option_confirmed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface NextStepClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * next_step_clicked: When clicking on the next arrow in the configurator
event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gDHTCF7LbHx}
 */
export function nextStepClicked(properties: NextStepClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "gDHTCF7LbHx", "427aaba960c5dbcf675d6abb41ef57c2393baf5d4a5a3425bc12523384c62ab9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("next_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("gDHTCF7LbHx", "next_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("next_step_clicked", eventProperties, "gDHTCF7LbHx", "427aaba960c5dbcf675d6abb41ef57c2393baf5d4a5a3425bc12523384c62ab9");
}
// destination Segment
Segment.logEvent("next_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface NextStepClickedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * next_step_clicked: When clicking on the next arrow in the configurator
event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Next" button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gDHTCF7LbHx.Cc4dWMqEQ/trigger/5BMLFdHOH_0
 * 2. When the user clicks in the arrow button to go to the next step
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gDHTCF7LbHx.Cc4dWMqEQ/trigger/eTA-ARz9m
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gDHTCF7LbHx.Cc4dWMqEQ}
 */
export function nextStepClickedBtc(properties: NextStepClickedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "gDHTCF7LbHx.Cc4dWMqEQ", "87e6f3132e52ac05bf7f794b68db8252794f98ad545f2c1312a1bbceece6b5ed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("next_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("gDHTCF7LbHx.Cc4dWMqEQ", "next_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("next_step_clicked", eventProperties, "gDHTCF7LbHx.Cc4dWMqEQ", "87e6f3132e52ac05bf7f794b68db8252794f98ad545f2c1312a1bbceece6b5ed");
}
// destination Segment
Segment.logEvent("next_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface FinalStepClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * final_step_clicked: This event represents user interactions with the options displayed in the configurator. It is utilized to monitor the frequency with which users switch between options within the same step. This one, in particular, represents the last step in a configurator. More details can be found in the variant's description.


event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/A1DO1tM0xmX}
 */
export function finalStepClicked(properties: FinalStepClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "A1DO1tM0xmX", "d13f5b7ebaefc0f6c153c0dd536c88790aa12b47b633119dea829a4db5a12524", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("final_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("A1DO1tM0xmX", "final_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("final_step_clicked", eventProperties, "A1DO1tM0xmX", "d13f5b7ebaefc0f6c153c0dd536c88790aa12b47b633119dea829a4db5a12524");
}
// destination Segment
Segment.logEvent("final_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface FinalStepClickedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * final_step_clicked: This event represents user interactions with the options displayed in the configurator. It is utilized to monitor the frequency with which users switch between options within the same step. This one, in particular, represents the last step in a configurator. More details can be found in the variant's description.


event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel, variant description: This event represents user interactions with the options displayed in the configurator. It is utilized to monitor the frequency with which users switch between options within the same step. This event represents the "Finish Look" button click in the Black Tie Configurator.
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Finish look" button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/A1DO1tM0xmX.8V9k9z2QC/trigger/RuoLa533hp_
 * 2. When the user clicks in the button to finish the look
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/A1DO1tM0xmX.8V9k9z2QC/trigger/T5-70xZ6N
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/A1DO1tM0xmX.8V9k9z2QC}
 */
export function finalStepClickedBtc(properties: FinalStepClickedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "A1DO1tM0xmX.8V9k9z2QC", "09501a90862b1274372a8029f41e894896a5b24377fb45de092a11712ed0812b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("final_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("A1DO1tM0xmX.8V9k9z2QC", "final_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("final_step_clicked", eventProperties, "A1DO1tM0xmX.8V9k9z2QC", "09501a90862b1274372a8029f41e894896a5b24377fb45de092a11712ed0812b");
}
// destination Segment
Segment.logEvent("final_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SummaryEditClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * summary_edit_clicked: When clicking on 'edit' icon on the summary screen 

- event_location: {{category}}_summary -> example cm_suits_summary
- option: jacket|trousers|waistcoat

 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_fPvWfx3Sl8}
 */
export function summaryEditClicked(properties: SummaryEditClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "_fPvWfx3Sl8", "c69bc13c1becdceb32d6ee4a24039032ee0eb5922278ff2bfa01bc40a24af7dd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("summary_edit_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("_fPvWfx3Sl8", "summary_edit_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_edit_clicked", eventProperties, "_fPvWfx3Sl8", "c69bc13c1becdceb32d6ee4a24039032ee0eb5922278ff2bfa01bc40a24af7dd");
}
// destination Segment
Segment.logEvent("summary_edit_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SummaryEditClickedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * summary_edit_clicked: When clicking on 'edit' icon on the summary screen 

- event_location: {{category}}_summary -> example cm_suits_summary
- option: jacket|trousers|waistcoat, event variant
 * 
 * When to trigger this event:
 * 1. When clicking 'Edit' button on summary screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_fPvWfx3Sl8.MAF3QYL-c/trigger/6nVk_EuQUyw
 * 2. When clicking 'Edit' button on summary screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_fPvWfx3Sl8.MAF3QYL-c/trigger/lAxU9FPe7
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/_fPvWfx3Sl8.MAF3QYL-c}
 */
export function summaryEditClickedBtc(properties: SummaryEditClickedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "_fPvWfx3Sl8.MAF3QYL-c", "3724aa98b65372003d8a9ac835faaedec907892d26cfdda0c09175a0c39b5b2d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("summary_edit_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("_fPvWfx3Sl8.MAF3QYL-c", "summary_edit_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("summary_edit_clicked", eventProperties, "_fPvWfx3Sl8.MAF3QYL-c", "3724aa98b65372003d8a9ac835faaedec907892d26cfdda0c09175a0c39b5b2d");
}
// destination Segment
Segment.logEvent("summary_edit_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSizeClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * select_size_clicked: When the user clicks in a change in the Select Size popup

 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QjaFGpR033V}
 */
export function selectSizeClicked(properties: SelectSizeClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QjaFGpR033V", "912f96c594820aae130a3e1d2b522fdbbf7dcd3340abf8945affdfdada4738a3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("select_size_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QjaFGpR033V", "select_size_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_size_clicked", eventProperties, "QjaFGpR033V", "912f96c594820aae130a3e1d2b522fdbbf7dcd3340abf8945affdfdada4738a3");
}
// destination Segment
Segment.logEvent("select_size_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SelectSizeClickedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * select_size_clicked: When the user clicks in a change in the Select Size popup, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Select size" button in the summary page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QjaFGpR033V.iyCfhkoLP/trigger/p9apvu7FzT7
 * 2. When the user clicks in the "Select size" button in the summary page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QjaFGpR033V.iyCfhkoLP/trigger/D83kK-Oj0
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_summary
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/QjaFGpR033V.iyCfhkoLP}
 */
export function selectSizeClickedBtc(properties: SelectSizeClickedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "QjaFGpR033V.iyCfhkoLP", "c09f9d474b8a1b01389be0d72172f00ec906301452275f1ae7badb2361ac529f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("select_size_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("QjaFGpR033V.iyCfhkoLP", "select_size_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_size_clicked", eventProperties, "QjaFGpR033V.iyCfhkoLP", "c09f9d474b8a1b01389be0d72172f00ec906301452275f1ae7badb2361ac529f");
}
// destination Segment
Segment.logEvent("select_size_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeConfirmedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * size_confirmed: When clicking on the 'confirm' button

option: {{SKU}}
event_location: example: btc_suits_shirt
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/j8BUIWlv2v}
 */
export function sizeConfirmed(properties: SizeConfirmedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "j8BUIWlv2v", "b355d4992d1f3dd32b06dc5a0dd8c7f5773d091754147e93614f49baa0ff4fc0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_confirmed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("j8BUIWlv2v", "size_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_confirmed", eventProperties, "j8BUIWlv2v", "b355d4992d1f3dd32b06dc5a0dd8c7f5773d091754147e93614f49baa0ff4fc0");
}
// destination Segment
Segment.logEvent("size_confirmed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SizeConfirmedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * size_confirmed: When clicking on the 'confirm' button

option: {{SKU}}
event_location: example: btc_suits_shirt, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Select size" button in the summary screen
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/j8BUIWlv2v._hAElxFpF/trigger/vfxF-tu1h4w
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: pop\-up
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/j8BUIWlv2v._hAElxFpF}
 */
export function sizeConfirmedBtc(properties: SizeConfirmedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "j8BUIWlv2v._hAElxFpF", "7f2f6560daddb48eb4fcc6f9d2175660797b7db9f43eab2d1d3919bc1e4c091f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("size_confirmed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("j8BUIWlv2v._hAElxFpF", "size_confirmed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("size_confirmed", eventProperties, "j8BUIWlv2v._hAElxFpF", "7f2f6560daddb48eb4fcc6f9d2175660797b7db9f43eab2d1d3919bc1e4c091f");
}
// destination Segment
Segment.logEvent("size_confirmed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PreviousStepClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * previous_step_clicked: When clicking on the next arrow in the configurator
event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eFhhXZXkYhp}
 */
export function previousStepClicked(properties: PreviousStepClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eFhhXZXkYhp", "bfe39b1ed839429fae7302820a3be33571d9cb44ccb210edfc9853c362781398", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("previous_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eFhhXZXkYhp", "previous_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("previous_step_clicked", eventProperties, "eFhhXZXkYhp", "bfe39b1ed839429fae7302820a3be33571d9cb44ccb210edfc9853c362781398");
}
// destination Segment
Segment.logEvent("previous_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PreviousStepClickedBtcProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  option: string;
  sku: string;
}
/**
 * previous_step_clicked: When clicking on the next arrow in the configurator
event_category: interactions
event_location: {{category}}_{{subcategory}} example: suits_jacket_lapel, event variant
 * 
 * When to trigger this event:
 * 1. When the user clicks in the "Previous" button
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eFhhXZXkYhp.Zf7UB1hBE/trigger/bKxYQul8PKh
 * 2. When the user clciks in the "Previous" icon 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eFhhXZXkYhp.Zf7UB1hBE/trigger/x1FjlGZEj
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel
, should match regex: configurator_(jacket|trousers|waistcoat|shirt|shoes|bow_tie|cufflinks|suspenders)
 * @param properties.option: This property describes the option chosen by the user when using a configurator tool.
 * @param properties.sku: SKU of product, same as product_id
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/eFhhXZXkYhp.Zf7UB1hBE}
 */
export function previousStepClickedBtc(properties: PreviousStepClickedBtcProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "0p2gAH62X", name: "option", value: properties.option});
eventPropertiesArray.push({id: "Yf36kEtqN", name: "sku", value: properties.sku});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "eFhhXZXkYhp.Zf7UB1hBE", "dbe922c8a9e9fcf31d5f7f6c8b09c97da6e409666eeaf0b8457ecfa32f48a8af", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("previous_step_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("eFhhXZXkYhp.Zf7UB1hBE", "previous_step_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("previous_step_clicked", eventProperties, "eFhhXZXkYhp.Zf7UB1hBE", "dbe922c8a9e9fcf31d5f7f6c8b09c97da6e409666eeaf0b8457ecfa32f48a8af");
}
// destination Segment
Segment.logEvent("previous_step_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CustomizationDetailsClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string | null | undefined;
  products: Products[];
}
/**
 * customization_details_clicked: This event occurs when a user clicks on the "Customization details" link after adding a product to the cart, either in the shopping cart or on the checkout page.
 * 
 * When to trigger this event:
 * 1. When the user clicks on the "Customization details" link after adding an item to the cart.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/rzmqCWNB6LFMtpW0mM6gv/trigger/zt-8jxkFaAJI5ycFT9PvL
 * 2. When the user selects the "Customization details" link on the checkout page.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/rzmqCWNB6LFMtpW0mM6gv/trigger/OpoJqgkzN9h-CZCAuSrF8
 * 3. When the user clicks on "Customization details" in the cart details page.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/rzmqCWNB6LFMtpW0mM6gv/trigger/FHozfHMqwta-pQCh1VSJY
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.products: An array of products needed for the specific event
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/rzmqCWNB6LFMtpW0mM6gv}
 */
export function customizationDetailsClicked(properties: CustomizationDetailsClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
properties.eventLocation !== undefined && properties.eventLocation !== null ?
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation}) :
  eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: null});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "rzmqCWNB6LFMtpW0mM6gv", "30fcd6fbc8a850a687781255b8fafa959526741a0bf43c1eb3fb93e9ed942c8b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("customization_details_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("rzmqCWNB6LFMtpW0mM6gv", "customization_details_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'customization_details_clicked': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("customization_details_clicked", eventProperties, "rzmqCWNB6LFMtpW0mM6gv", "30fcd6fbc8a850a687781255b8fafa959526741a0bf43c1eb3fb93e9ed942c8b");
}
// destination Segment
Segment.logEvent("customization_details_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ProductImageSliderInteractedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  products: Products[];
  eventCategory: EventCategoryValueType;
}
/**
 * product_image_slider_interacted: This event represents when a user clicks on the product slider to see other images available for that item. 

This event is only fired once per product. 
 * 
 * When to trigger this event:
 * 1. This event is triggered whenever the user clicks on an arrow control to change the displayed product image or when the user slides the product images
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DV1A9z_-jSZ6-qQRRS9xV/trigger/qziR_DBD9D4ZStYaPEt-J
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.products: An array of products needed for the specific event
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DV1A9z_-jSZ6-qQRRS9xV}
 */
export function productImageSliderInteracted(properties: ProductImageSliderInteractedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "rg6ssTw5D", name: "products", value: properties.products.map(function(value) { return {
    "product_id": value.productId,
    "category": value.category,
    "item_category2": value.itemCategory2,
    "item_category3": value.itemCategory3,
    "item_category4": value.itemCategory4,
    "item_category5": value.itemCategory5,
    "affiliation": value.affiliation,
    "item_list_name": value.itemListName,
    "brand": "suitsupply",
    "variant": value.variant,
    "price": value.price,
    "quantity": value.quantity,
    "currency": value.currency,
    "position": value.position,
    "image_url": value.imageUrl,
    "online_material": value.onlineMaterial,
    "fit_id": value.fitId,
    "plp_grid_images": value.plpGridImages,
    "shop_the_look_id": value.shopTheLookId,
    "mix_and_match": value.mixAndMatch,
    "product_set_id": value.productSetId,
    "name": value.name,
    "list_id": value.listId,
    "sku": value.sku,
    "full_look": value.fullLook,
    "value": value.value,
    "location_id": value.locationId,
    "url": value.url,
    "custom_size": value.customSize,
    "included_alterations": value.includedAlterations,
    "has_sizepassport": value.hasSizepassport,
    "out_of_stock": value.outOfStock,
    "slider_image_number": value.sliderImageNumber,
    "has_image_slider_interaction": value.hasImageSliderInteraction,
}
})});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertProducts(properties.products));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "DV1A9z_-jSZ6-qQRRS9xV", "3522e37b05533217048eac68b66aafca10fbac4f5db0ef7bd2966751370dda34", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("product_image_slider_interacted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("DV1A9z_-jSZ6-qQRRS9xV", "product_image_slider_interacted", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'product_image_slider_interacted': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("product_image_slider_interacted", eventProperties, "DV1A9z_-jSZ6-qQRRS9xV", "3522e37b05533217048eac68b66aafca10fbac4f5db0ef7bd2966751370dda34");
}
// destination Segment
Segment.logEvent("product_image_slider_interacted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SearchClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Search button. 
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/tJdEwNjByERhlix662YbL/trigger/PuHYswmL1GCfyuvBa-Fhn
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/tJdEwNjByERhlix662YbL}
 */
export function searchClicked(properties: SearchClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL", "e1a471cfd233323a47c0e8912f1e0ea9b1f287e556a62496ac7c3d66c5e449fb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("tJdEwNjByERhlix662YbL", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL", "e1a471cfd233323a47c0e8912f1e0ea9b1f287e556a62496ac7c3d66c5e449fb");
}
// destination Segment
Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SearchClickedCustomMadeProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * search_clicked: This event represents the action of clicking the search icon to initiate a search on the website, variant description: This event represents when a user clicks in the Search to search for an option in the custom made tool
 * 
 * When to trigger this event:
 * 1. When the user clicks in the Search button on custom made tool
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW/trigger/iijYELtg_Y2ORJLUVujKR
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW}
 */
export function searchClickedCustomMade(properties: SearchClickedCustomMadeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "7cb422b83876781f1cbc2992a644d3c870f0bc027449c6f13043af141822fa02", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("search_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "search_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_clicked", eventProperties, "tJdEwNjByERhlix662YbL.rThksAXKqjq3pVcTtRFJW", "7cb422b83876781f1cbc2992a644d3c870f0bc027449c6f13043af141822fa02");
}
// destination Segment
Segment.logEvent("search_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TermSearchedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  term: string;
}
/**
 * term_searched: This event represents a term search by the user in the website. This term does not require formatting and should accurately reflect the user's search query.
 * 
 * When to trigger this event:
 * 1. This events is triggered when the user search for a term in any page
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gjIsl0QB7zu/trigger/XIpMG_3goaL
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.term: This property represents the term search by the user. The value for this property does not require formatting and should precisely match the user's search input.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/gjIsl0QB7zu}
 */
export function termSearched(properties: TermSearchedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "XEvmyYNjO", name: "term", value: properties.term});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "gjIsl0QB7zu", "f588c60cf4409cf9de11384ad6451acfa0be1642e4f7eedc3de4d25457f2d2cb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("term_searched", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("gjIsl0QB7zu", "term_searched", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("term_searched", eventProperties, "gjIsl0QB7zu", "f588c60cf4409cf9de11384ad6451acfa0be1642e4f7eedc3de4d25457f2d2cb");
}
// destination Segment
Segment.logEvent("term_searched", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CountrySelectorClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string | null | undefined;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * country_selector_clicked: This event represents the user interaction with the country selector feature to change the website's country
 * 
 * When to trigger this event:
 * 1. When the user selects a country to modify the website's country
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DCYjjFCaVO/trigger/AnFTKc6UEY
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/DCYjjFCaVO}
 */
export function countrySelectorClicked(properties: CountrySelectorClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
properties.eventLabel !== undefined && properties.eventLabel !== null ?
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel}) :
  eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: null});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "DCYjjFCaVO", "d913bdfb56437a68763790085c64eeb1216011af997256e488e4a38ee6f71b63", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("country_selector_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("DCYjjFCaVO", "country_selector_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("country_selector_clicked", eventProperties, "DCYjjFCaVO", "d913bdfb56437a68763790085c64eeb1216011af997256e488e4a38ee6f71b63");
}
// destination Segment
Segment.logEvent("country_selector_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LanguageSelectorClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
}
/**
 * language_selector_clicked: This event is triggered when the user chooses a new language in the language selector

event_location: menu|pop-up|footer
 * 
 * When to trigger this event:
 * 1. When the user clicks on the language selector to change the current website language.
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/LG6GJYuVuR7RTTo6iqBio/trigger/rf2Q1aaSeNr_ZuIAWRX8B
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/LG6GJYuVuR7RTTo6iqBio}
 */
export function languageSelectorClicked(properties: LanguageSelectorClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "LG6GJYuVuR7RTTo6iqBio", "6da1eacdef34d459ff620c15da512b12ee3bae01c3054d162a969168264feb63", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("language_selector_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("LG6GJYuVuR7RTTo6iqBio", "language_selector_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("language_selector_clicked", eventProperties, "LG6GJYuVuR7RTTo6iqBio", "6da1eacdef34d459ff620c15da512b12ee3bae01c3054d162a969168264feb63");
}
// destination Segment
Segment.logEvent("language_selector_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SearchResultClickedProperties {
  currency: CurrencyValueType;
  country: CountryValueType;
  language: LanguageValueType;
  url: string;
  locationId: string;
  userId: string;
  loggedIn: LoggedInValueType;
  pageType: PageTypeValueType;
  gaClientId: string | null | undefined;
  gaSessionId: string | null | undefined;
  gaSessionNumber: string | null | undefined;
  fbFbp: string | null | undefined;
  fbFbc: string | null | undefined;
  gaAwClid: string | null | undefined;
  eventLabel: string;
  eventCategory: EventCategoryValueType;
  eventLocation: string;
  term: string;
}
/**
 * search_result_clicked: This event represents when the user clicks in a search result
 * 
 * When to trigger this event:
 * 1. When the user clicks in a search result after using the search
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/oNETgAtgVQU6NIWi3-rab/trigger/s4OiClLcgD54FgBj_qcZ5
 * 
 * @param properties the properties associatied with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad. 
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be. 
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page. 
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.' 
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below 



- For wishlist panel: wishlist_panel
- For add to bag panel: minicart_panel
- For OOS panel: oos
- For out-of-stock panel: out_of_stock_panel
- For shop the look panel: 'products_mwtw_{{number}}'
- For mix and match panel: mixandmatch
- for Perfect White shirt finder: pwsf_panel
- For Size Passport: size-passport_panel
- For PDP size guide button: pdp
- For LB: lookbuilder_summary
- For Similar Products: similar_products_panel

 * @param properties.term: This property represents the term search by the user. The value for this property does not require formatting and should precisely match the user's search input.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/2LaGwaVhj/events/oNETgAtgVQU6NIWi3-rab}
 */
export function searchResultClicked(properties: SearchResultClickedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "jhDpoElQU", name: "currency", value: properties.currency});
eventPropertiesArray.push({id: "bCDyX8-bZ", name: "country", value: properties.country});
eventPropertiesArray.push({id: "8iHihZ0rO", name: "language", value: properties.language});
eventPropertiesArray.push({id: "olJP9CQ0tb", name: "url", value: properties.url});
eventPropertiesArray.push({id: "memdKZdQJ1", name: "location_id", value: properties.locationId});
eventPropertiesArray.push({id: "piJkZJx8sqS", name: "user_id", value: properties.userId});
eventPropertiesArray.push({id: "Kvhizl7kAi", name: "logged_in", value: properties.loggedIn});
eventPropertiesArray.push({id: "gppkY78PuY", name: "page_type", value: properties.pageType});
properties.gaClientId !== undefined && properties.gaClientId !== null ?
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: properties.gaClientId}) :
  eventPropertiesArray.push({id: "ba9__C5yS", name: "ga_client_id", value: null});
properties.gaSessionId !== undefined && properties.gaSessionId !== null ?
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: properties.gaSessionId}) :
  eventPropertiesArray.push({id: "sFU-LulvR", name: "ga_session_id", value: null});
properties.gaSessionNumber !== undefined && properties.gaSessionNumber !== null ?
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: properties.gaSessionNumber}) :
  eventPropertiesArray.push({id: "QQnci_8-j", name: "ga_session_number", value: null});
properties.fbFbp !== undefined && properties.fbFbp !== null ?
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: properties.fbFbp}) :
  eventPropertiesArray.push({id: "MlkVULjI2U", name: "fb_fbp", value: null});
properties.fbFbc !== undefined && properties.fbFbc !== null ?
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: properties.fbFbc}) :
  eventPropertiesArray.push({id: "ftuMAZCD8", name: "fb_fbc", value: null});
properties.gaAwClid !== undefined && properties.gaAwClid !== null ?
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: properties.gaAwClid}) :
  eventPropertiesArray.push({id: "tUxjzh1QQ", name: "ga_aw_clid", value: null});
eventPropertiesArray.push({id: "5mI3k6x6_", name: "event_label", value: properties.eventLabel});
eventPropertiesArray.push({id: "VdCb01TKRz", name: "event_category", value: properties.eventCategory});
eventPropertiesArray.push({id: "te07FO5wjg", name: "event_location", value: properties.eventLocation});
eventPropertiesArray.push({id: "XEvmyYNjO", name: "term", value: properties.term});
eventPropertiesArray.push({id: "y5SNyT2mhIug4Phnigv9w", name: "application_id", value: sysApplicationId});
eventPropertiesArray.push({id: "DMwzDVuWySom_STXGbcIW", name: "version", value: sysVersion});
eventPropertiesArray.push({id: "sp1EZQB2ui7cjP8pHZGCB", name: "client_id", value: sysClientId});
eventPropertiesArray.push({id: "tvmsJLhx1juKCS3PNg84A", name: "session_id", value: sysSessionId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "oNETgAtgVQU6NIWi3-rab", "b4316152cf3ac964c474ab24ca8dd4e9454d659dba8859482bcc9b07df32dfaa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("search_result_clicked", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("oNETgAtgVQU6NIWi3-rab", "search_result_clicked", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_result_clicked", eventProperties, "oNETgAtgVQU6NIWi3-rab", "b4316152cf3ac964c474ab24ca8dd4e9454d659dba8859482bcc9b07df32dfaa");
}
// destination Segment
Segment.logEvent("search_result_clicked", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  MixAndMatch,
  Language,
  NewCountry,
  LoggedIn,
  EventCategory,
  Country,
  Affiliation,
  Brand,
  PageType,
  Currency,
  Creative,
  ApplicationId,
  productListViewed,
  productListViewedSimilarProducts,
  productClicked,
  productClickedSimilarProducts,
  productViewed,
  productAdded,
  productAddedCm,
  pageLoaded,
  pageLoadedVirtualPageView,
  promotionViewed,
  promotionViewedShopTheLookSlider,
  promotionClicked,
  promotionClickedShopTheLookSlider,
  productAddedToWishlist,
  productAddedToWishlistOutOfStock,
  selectSize,
  selectSizeSimilarProducts,
  sizeChanged,
  sizeChangedSimilarProducts,
  sizeChangedBtc,
  countryChanged,
  languageChanged,
  headerAccountClick,
  headerLogoClick,
  viewMinicartClicked,
  headerWishlistClick,
  menuClicked,
  footerClick,
  newsletterSubscribe,
  fabricOptionSelect,
  fabricOptionConfirm,
  styleOptionSelect,
  styleOptionSelectBtc,
  styleOptionSelectCm,
  styleOptionConfirm,
  summaryEdit,
  styleOptionChange,
  styleOptionChangeConfirm,
  styleOptionChangeCancel,
  jacketOptionSelect,
  shirtOptionSelect,
  shoesOptionSelect,
  bowtieOptionSelect,
  cufflinkOptionSelect,
  suspendersOptionSelect,
  btcSummaryEdit,
  previousStep,
  nextStep,
  sizeGuideClick,
  sizeGuideClickSimilarProducts,
  sizeConfirm,
  trousersOptionSelect,
  waistcoatOptionSelect,
  lookChanged,
  optionSelected,
  optionSelectedBtc,
  optionConfirmed,
  optionConfirmedBtc,
  nextStepClicked,
  nextStepClickedBtc,
  finalStepClicked,
  finalStepClickedBtc,
  summaryEditClicked,
  summaryEditClickedBtc,
  selectSizeClicked,
  selectSizeClickedBtc,
  sizeConfirmed,
  sizeConfirmedBtc,
  previousStepClicked,
  previousStepClickedBtc,
  customizationDetailsClicked,
  productImageSliderInteracted,
  searchClicked,
  searchClickedCustomMade,
  termSearched,
  countrySelectorClicked,
  languageSelectorClicked,
  searchResultClicked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["productListViewed","productListViewedSimilarProducts","productClicked","productClickedSimilarProducts","productViewed","productAdded","productAddedCm","pageLoaded","pageLoadedVirtualPageView","promotionViewed","promotionViewedShopTheLookSlider","promotionClicked","promotionClickedShopTheLookSlider","productAddedToWishlist","productAddedToWishlistOutOfStock","selectSize","selectSizeSimilarProducts","sizeChanged","sizeChangedSimilarProducts","sizeChangedBtc","countryChanged","languageChanged","headerAccountClick","headerLogoClick","viewMinicartClicked","headerWishlistClick","menuClicked","footerClick","newsletterSubscribe","fabricOptionSelect","fabricOptionConfirm","styleOptionSelect","styleOptionSelectBtc","styleOptionSelectCm","styleOptionConfirm","summaryEdit","styleOptionChange","styleOptionChangeConfirm","styleOptionChangeCancel","jacketOptionSelect","shirtOptionSelect","shoesOptionSelect","bowtieOptionSelect","cufflinkOptionSelect","suspendersOptionSelect","btcSummaryEdit","previousStep","nextStep","sizeGuideClick","sizeGuideClickSimilarProducts","sizeConfirm","trousersOptionSelect","waistcoatOptionSelect","lookChanged","optionSelected","optionSelectedBtc","optionConfirmed","optionConfirmedBtc","nextStepClicked","nextStepClickedBtc","finalStepClicked","finalStepClickedBtc","summaryEditClicked","summaryEditClickedBtc","selectSizeClicked","selectSizeClickedBtc","sizeConfirmed","sizeConfirmedBtc","previousStepClicked","previousStepClickedBtc","customizationDetailsClicked","productImageSliderInteracted","searchClicked","searchClickedCustomMade","termSearched","countrySelectorClicked","languageSelectorClicked","searchResultClicked"]
